// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-08-27T21:39:34.461Z
// Property: Cedar Glade Apts (ID: 6767906449165588)
// Collections: 22 amenities, 4 floorplans (live), 33 photos, 63 POIs, 4 reviews, 1 virtual tours, 6 office hours
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5767906449162419",
  "multihub_property_id": "6767906449165588",
  "property_external_id": "n94q3hp",
  "property_zillow_url": "https://www.zillow.com/b/9713-e-75th-st-s-tulsa-ok-BT3Pbf/",
  "property_apartments_url": "https://www.apartments.com/cedar-glade-apts-tulsa-ok/n94q3hp/",
  "property_google_business_url": "https://www.google.com/maps/place/Cedar+Glade+Apartments/data=!4m2!3m1!1s0x0:0xc807cf73d1ac0d32?sa=X&ved=2ahUKEwj62c758rySAxUhl4kEHQh9F7QQ_BJ6BAgREAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": null,
  "property_crm_software": "Yardi RentCafe",
  "property_pm_software": "Yardi",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "cedar-glade-apts",
  "property_name": "Cedar Glade Apts",
  "property_website_url": "https://www.caseusa.com/apartments/ok/tulsa/cedar-glade/",
  "property_domain": null,
  "property_address": "9713 East 75th St.",
  "property_full_address": "9713 East 75th St., Tulsa, OK, 74133",
  "property_address_1": "9713 East 75th St.",
  "property_address_2": null,
  "property_address_city": "Tulsa",
  "property_address_state": "OK",
  "property_address_zip_full": null,
  "property_address_zip": "74133",
  "property_address_country": "US",
  "property_address_county": "Tulsa County",
  "property_neighborhood_address": "South Tulsa",
  "property_address_latitude": "36.0571",
  "property_address_longitude": "-95.86726",
  "property_email": "cedarglade@caseusa.com",
  "property_phone": "(539) 379-4400",
  "property_call_tracking_phone": "833-239-2970",
  "property_company_name": "Case & Associates",
  "property_company_url": "https://www.caseusa.com/",
  "agency_contacts": null,
  "property_type": "Apartments",
  "property_short_description": "Welcome to Cedar Glade Apartments in Tulsa, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, and enjoy exceptional amenities like a refreshing pool, a state-of-the-art fitness center, and a dog park. Your ideal sanctuary awaits—browse our availability and schedule a tour today! Prefer to explore on your own time? Self-guided tours are available.",
  "property_long_description": "Welcome to Cedar Glade Apartments, where comfort and convenience meet in the heart of Tulsa, Oklahoma. Our diverse range of floor plans, including stylish one, two, and three-bedroom apartments, ensures there's the perfect home for everyone. Each residence is designed with modern living in mind, featuring amenities such as air conditioning, a spacious kitchen with a microwave and dishwasher, and convenient washer/dryer hookups. \n\nAt Cedar Glade, we understand the importance of relaxation and recreation. Dive into our sparkling pool on warm summer days, or stay active in our state-of-the-art fitness center. For gatherings and social events, our inviting clubhouse and picnic area provide the perfect settings. Our community is also pet-friendly, complete with a dog park where your four-legged friends can roam and play. \n\nEnjoy the ease of on-site maintenance and a dedicated property manager committed to ensuring your comfort and satisfaction. With high-speed internet access and cable-ready apartments, you'll stay connected in style. Our spacious homes also feature thoughtful touches like ceiling fans, fireplaces, and ample storage space, making Cedar Glade Apartments a place you'll love coming home to.\n\nExperience the perfect blend of suburban charm and modern amenities at Cedar Glade Apartments. Find your new home today—browse our availability or schedule a tour to visit our welcoming community! Your ideal lifestyle awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb3a-549f-70fe-a904-92d8df77f0dd.webp",
  "property_featured_image_media": {
    "alt_text": "Aerial view of an apartment complex with buildings, parking lots, and surrounding roads.",
    "public_id": "019cfb3a-549f-70fe-a904-92d8df77f0dd",
    "storage_key": "property/6767906449165588/019cfb3a-549f-70fe-a904-92d8df77f0dd.webp",
    "width": 2048,
    "height": 1365
  },
  "property_featured_video": null,
  "property_featured_video_media": null,
  "property_total_units": "276",
  "property_year_built": "1984",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "97.10144927536231",
  "property_admin_fee": null,
  "property_application_fee": "75",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": "0",
  "property_monthly_pet_rent": "30",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "0",
  "property_pet_restrictions": "Contact Leasing Office for details",
  "property_pet_policy_description": "Pets Welcome - Contact Leasing Office for details",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://cedargladeapartmentstulsa.securecafe.com/onlineleasing/cedar-glade-apts/floorplans.aspx",
  "property_resident_portal_url": "https://cedargladeapartmentstulsa.securecafe.com/residentservices/cedar-glade-apts/userlogin.aspx",
  "property_apply_now_url": "https://cedargladeapartmentstulsa.securecafe.com/onlineleasing/cedar-glade-apts/register.aspx",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-4343-72dc-aba1-260758975725.webp",
  "property_primary_logo_media": {
    "alt_text": "Cedar Glade logo",
    "public_id": "019cfb39-4343-72dc-aba1-260758975725",
    "storage_key": "property/6767906449165588/019cfb39-4343-72dc-aba1-260758975725.webp",
    "width": 2400,
    "height": 1471
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb3a-484e-700d-bc56-d687fb78e533.webp",
  "property_secondary_logo_media": {
    "alt_text": "CASE & ASSOCIATES logo",
    "public_id": "019cfb3a-484e-700d-bc56-d687fb78e533",
    "storage_key": "property/6767906449165588/019cfb3a-484e-700d-bc56-d687fb78e533.webp",
    "width": 325,
    "height": 325
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-4343-72dc-aba1-260758975725.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Cedar Glade logo",
    "public_id": "019cfb39-4343-72dc-aba1-260758975725",
    "storage_key": "property/6767906449165588/019cfb39-4343-72dc-aba1-260758975725.webp",
    "width": 640,
    "height": 392
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb3a-792c-776b-935f-0d4d8e1f54d9.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Cedar Glade logo",
    "public_id": "019cfb3a-792c-776b-935f-0d4d8e1f54d9",
    "storage_key": "property/6767906449165588/019cfb3a-792c-776b-935f-0d4d8e1f54d9.webp",
    "width": 640,
    "height": 392
  },
  "property_company_icon": null,
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
  "property_company_logo_media": {
    "alt_text": "Case & Associates logo",
    "public_id": "019cfb35-ce4c-7138-92b0-dd454c056e38",
    "storage_key": "company/5767906449162419/019cfb35-ce4c-7138-92b0-dd454c056e38.webp",
    "width": 640,
    "height": 256
  },
  "property_company_mono_black_logo": null,
  "property_company_mono_black_logo_media": null,
  "property_company_mono_white_logo": null,
  "property_company_mono_white_logo_media": null,
  "property_primary_color": "#64695c",
  "property_secondary_color": "#c4b7a5",
  "property_font_color": null,
  "property_color_4": null,
  "property_color_3": "#636569",
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "725 - 1050",
  "property_sqft_min": "725",
  "property_sqft_max": "1050",
  "property_price_range": "909 - 1179",
  "property_price_min": "909",
  "property_price_max": "1179",
  "property_available_units": 8,
  "property_facebook_url": "https://www.facebook.com/CedarGladeTulsa/",
  "property_instagram_url": "https://www.instagram.com/cedargladetulsa?igsh=MWZzcDE0d2huNTY3Zg==",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJTclaJriNtocRMg2s0XPPB8g",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/cedar-glade-apartments-tulsa-2",
  "property_tiktok_url": "https://www.tiktok.com/@cedar.glade?_r=1&_t=ZT-95oH7JjrQAo",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to Cedar Glade Apts",
  "property_home_romance_title": "Embrace a Life You’ll Love in Our Vibrant Community",
  "property_home_amenities_blurb": "At Cedar Glade Apts in Tulsa, experience modern living tailored for comfort. Choose from one, two, or three-bedroom floor plans featuring spacious layouts and convenient amenities like a refreshing pool, a well-equipped fitness center, and a welcoming dog park. Embrace community and relaxation in your new home today!",
  "property_home_floorplans_blurb": "At Cedar Glade Apts in Tulsa, Oklahoma, we offer a variety of thoughtfully designed floor plans tailored to fit your lifestyle. Whether you’re seeking a cozy one-bedroom, a spacious two-bedroom, or a generous three-bedroom, your ideal home awaits. Browse our available apartment homes today and elevate your living experience!",
  "property_home_gallery_blurb": "Welcome to Cedar Glade Apartments in the heart of Tulsa, Oklahoma, where comfort meets convenience. With spacious one, two, and three-bedroom floor plans and a variety of amenities—like a refreshing pool, fitness center, and dog park—this is more than just a home; it’s a lifestyle. Picture yourself living here!",
  "property_home_neighborhood_blurb": "At Cedar Glade Apts in Tulsa, immerse yourself in a vibrant community that blends comfort with adventure. With one, two, and three-bedroom floor plans, you'll find the perfect home. Enjoy nearby attractions like the Oklahoma Aquarium, Oral Roberts University, and lush parks, ensuring there's never a dull moment just outside your door.",
  "property_home_reviews_blurb": "At Cedar Glade Apts in Tulsa, Oklahoma, residents rave about our warm, friendly staff and exceptional maintenance service. With a perfect 5-star rating, one resident noted, “They always come when they say they will and do a good job.” Experience the comfort and responsiveness of our community today!",
  "property_neighborhood_blurb": "At Cedar Glade Apartments in Tulsa, we offer a vibrant lifestyle surrounded by cultural gems and outdoor spaces. Enjoy nearby attractions like the Oklahoma Aquarium, Hardesty Regional Library, and LaFortune Park. Unwind at the Urban Air Trampoline Park or catch a show at the Mabee Center. Experience the perfect blend of convenience and adventure!",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "At Cedar Glade Apts in Tulsa, enjoy a lifestyle of comfort and convenience. Choose from our spacious one, two, or three-bedroom floor plans. Revel in amenities like a refreshing pool, modern fitness center, and inviting dog park, all designed for your leisure and enjoyment. Come envision your new home today!",
  "property_applynow_blurb": "Welcome to Cedar Glade Apartments in Tulsa, where comfort meets convenience. Choose from spacious one, two, or three-bedroom floor plans, each featuring modern amenities like a refreshing pool, fitness center, and dog park. Ready to elevate your lifestyle? Lease your new home online today!",
  "property_contactus_blurb": "At Cedar Glade Apartments in Tulsa, Oklahoma, we offer diverse floor plans to match your lifestyle—choose from cozy one-bedroom retreats to spacious three-bedroom homes. Every layout is thoughtfully designed for comfort and style. Have questions? Reach out to our leasing team today and let’s find your perfect home!",
  "property_faqs_blurb": "At Cedar Glade Apts in Tulsa, Oklahoma, we offer thoughtfully designed one, two, and three-bedroom floor plans to fit your lifestyle. Curious about amenities, pet policies, or utilities? Our FAQs page is your go-to resource for all your burning questions. Dive in and get informed today!",
  "property_floorplans_blurb": "At Cedar Glade Apts in Tulsa, Oklahoma, we offer thoughtfully designed one, two, and three-bedroom floor plans tailored to fit your lifestyle. Each space combines comfort with functionality, ensuring you feel right at home. Browse our available apartment homes and uncover your ideal living arrangement today!",
  "property_gallery_blurb": "Nestled in Tulsa, Cedar Glade Apartments offers a harmonious blend of comfort and convenience. Choose from spacious one, two, or three-bedroom floor plans while enjoying top-notch amenities like a refreshing pool, vibrant dog park, and inviting clubhouse. Picture yourself living here and feel right at home!",
  "property_interactivemap_blurb": "At Cedar Glade Apts in Tulsa, find your perfect floor plan—whether it’s a cozy one-bedroom or a spacious three-bedroom suite. With amenities from a refreshing pool to a welcoming dog park, you’ll love calling this community home. Check out our interactive map to begin your journey today!",
  "property_pets_blurb": "At Cedar Glade Apartments in Tulsa, OK, your furry friends are part of the family! Our pet-friendly community ensures comfort and joy for every resident, with ample outdoor space for playtime. Contact our leasing office for details and make your apartment a home for both you and your pets.",
  "property_referafriend_blurb": "At Cedar Glade Apts in Tulsa, Oklahoma, find the perfect floor plan to suit your lifestyle, whether it's a cozy one-bedroom or a spacious three-bedroom. Great friends make great neighbors—refer a friend to our vibrant community today and embrace a life filled with connections and comfort!",
  "property_residentaccess_blurb": "Welcome to Cedar Glade Apartments in Tulsa, Oklahoma! Our diverse floor plans, featuring one, two, and three-bedroom options, cater to every lifestyle. Access your resident portal now to effortlessly pay rent, schedule maintenance, and unlock the full range of community amenities. Your seamless living experience starts here!",
  "property_reviews_blurb": "At Cedar Glade Apartments in Tulsa, our residents consistently rave about our attentive staff and rapid maintenance response. One resident notes, “The staff is always wonderful and courteous,” while another highlights our team’s impressive ability to promptly tackle service needs. Experience community living where your comfort is our priority!",
  "property_created_at": "1753982378590",
  "property_scheduletour_blurb": "At Cedar Glade Apts in Tulsa, Oklahoma, choose from spacious one, two, or three-bedroom floor plans tailored to your lifestyle. Experience vibrant community living and hear firsthand from our residents about their home sweet home. Schedule your tour today and find your perfect retreat amidst nature’s beauty!",
  "property_thankyou_blurb": "Thank you for reaching out about Cedar Glade Apts in the heart of Tulsa, Oklahoma. With thoughtfully designed one, two, and three-bedroom floor plans, your ideal living space awaits. Expect a warm welcome from our team, who will connect with you soon to guide your journey home!",
  "property_virtualtours_blurb": "At Cedar Glade Apts in Tulsa, Oklahoma, our diverse floor plans—ranging from cozy one-bedroom retreats to spacious three-bedroom havens—invite you to envision your new lifestyle. Step into comfort and style; take a virtual tour of our community and apartments for rent today! Your perfect home awaits!",
  "property_copyright": "2025 All Rights Reserved. Cedar Glade Apts",
  "property_seo_title_home": "Cedar Glade Apts |  Apartments in Tulsa, Oklahoma",
  "property_seo_description_home": "Elevate your lifestyle at Cedar Glade Apts in Tulsa! Choose from spacious one to three-bedroom layouts with premier amenities like a pool, dog park, and more.",
  "property_seo_title_floorplans": "Floor Plans | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_floorplans": "Discover your perfect home at Cedar Glade Apts in Tulsa! Explore our stylish one, two, and three-bedroom floor plans today!",
  "property_seo_title_amenities": "Amenities | Tulsa, Oklahoma Apartments for Rent",
  "property_seo_description_amenities": "Discover comfort at Cedar Glade Apartments in Tulsa! Enjoy amenities like a pool, fitness center, and dog park—your ideal home awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Tulsa, Oklahoma",
  "property_seo_description_gallery": "Picture life at Cedar Glade Apts in Tulsa, OK! Enjoy spacious 1-3 bedroom homes, stellar amenities, and a welcoming community. Your perfect escape awaits!",
  "property_seo_title_virtualtours": "Virtual Tours | Cedar Glade Apts Apartments",
  "property_seo_description_virtualtours": "Step into your future home at Cedar Glade Apts in Tulsa! Take a virtual tour and view our spacious one to three-bedroom floor plans today!",
  "property_seo_title_interactivemap": "Interactive Map | Cedar Glade Apts Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at Cedar Glade Apts in Tulsa. Use our interactive map to explore spacious one, two, and three-bedroom layouts with top-notch amenities!",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Tulsa, Oklahoma",
  "property_seo_description_neighborhood": "Uncover the vibrant neighborhood surrounding Cedar Glade Apts in Tulsa. From local favorites to hidden gems, find your perfect community vibe today!",
  "property_seo_title_contact": "Contact Us | Cedar Glade Apts",
  "property_seo_description_contact": "Connect with Cedar Glade Apts in Tulsa for personalized leasing support. Inquire about our one, two, and three-bedroom floor plans today!",
  "property_seo_title_faqs": "FAQs | Apartments in Tulsa, Oklahoma",
  "property_seo_description_faqs": "Get answers to all your questions about Cedar Glade Apts in Tulsa! From amenities to floor plans, find everything you need to know in our FAQs.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Tulsa, Oklahoma",
  "property_seo_description_reviews": "Discover Cedar Glade Apts in Tulsa! Read resident reviews and see why our one to three-bedroom homes and amenities stand out in our vibrant community.",
  "property_seo_title_applynow": "Apply Now | Apartments in Tulsa, Oklahoma",
  "property_seo_description_applynow": "Find your haven at Cedar Glade Apts in Tulsa! Choose from spacious floor plans, enjoy luxurious amenities, and lease your new home online today!",
  "property_seo_title_residentaccess": "Resident Access | Cedar Glade Apts",
  "property_seo_description_residentaccess": "Login to your Cedar Glade Apts portal! Easily pay rent, request maintenance, and stay connected with your Tulsa community. Your comfort, just a click away!",
  "property_seo_title_referafriend": "Refer A Friend | Cedar Glade Apts",
  "property_seo_description_referafriend": "Refer a friend to Cedar Glade Apts in Tulsa! Great friends make even better neighbors. Share the joy of our welcoming community today!",
  "property_seo_title_scheduletour": "Schedule a Tour | Cedar Glade Apts",
  "property_seo_description_scheduletour": "Experience vibrant living at Cedar Glade Apts in Tulsa! Embrace stylish homes and serene surroundings. Schedule a tour today and envision your new lifestyle!",
  "property_seo_title_privacy": "Privacy Policy | Cedar Glade Apts",
  "property_seo_description_privacy": "At Cedar Glade Apts in Tulsa, your privacy matters. Dive into our commitment to safeguarding your information. View our privacy policy for peace of mind.",
  "property_seo_title_accessibility": "Website Accessibility | Cedar Glade Apts",
  "property_seo_description_accessibility": "At Cedar Glade Apts in Tulsa, we prioritize accessibility for all. Join us in fostering a community where everyone feels at home. Your input matters!",
  "property_seo_title_sitemap": "Sitemap | Cedar Glade Apts",
  "property_seo_description_sitemap": "Explore Cedar Glade Apts in Tulsa! Use our sitemap to easily discover amenities, floor plans, and what makes our community home.",
  "property_seo_title_thankyou": "Thank You | Cedar Glade Apts",
  "property_seo_description_thankyou": "Thank you for reaching out to Cedar Glade Apts in Tulsa! We're excited to connect with you soon about your new home in our vibrant community.",
  "property_seo_title_pets": "Pet Policy | Apartments in Tulsa, OK",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1787864900822",
  "amenities": [
    {
      "id": "ec_171a7a928a4462b4cf66c55b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127396282",
      "title": "24-Hour Fitness Center with Free Weights",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_48427a0acfa482af6196aee7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127396283",
      "title": "Sparkling Swimming Pools",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_35d16da0d698ca8956ae283c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127396284",
      "title": "Community Courtyard",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b0280483382512459b2d1b1d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127396285",
      "title": "Resident Clubhouse",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_07312d6b85c732ffa060b6b3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127396286",
      "title": "Business Center",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_d2a77171d725ad20f0f2b9bc",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127396287",
      "title": "Onsite Management",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_30ea396dd7657a287c18d0b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127396288",
      "title": "flex. Payment Options Available",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_aa73a625c00153d4da6307c8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127396289",
      "title": "24-Hour Emergency Maintenance",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_6cdc05f1a1db29a24d99d5c2",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127396290",
      "title": "Union School District",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_2710acfa872f6c932caf3852",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127396291",
      "title": "BBQ/Picnic Area",
      "amount": "false",
      "description": "false",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_70c0246c13f7456a9deb50a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397791",
      "title": "Ceiling Fan",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9e8ccee91e2d5e9546eaac94",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397792",
      "title": "Carpeting",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_391f8846f4ff877644d49e2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397793",
      "title": "Efficient Appliances",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_b1a9997ef015f75151354921",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397794",
      "title": "Washer & Dryer Connections",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_9effea32957c4528ec261290",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397795",
      "title": "Large Bedroom Closets",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_e06e6601b5aaaa1b9523a363",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397796",
      "title": "Wood-Burning Fireplace w/ Mantel*",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_f274eb97831672884cd59307",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397797",
      "title": "Extra Storage",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_4806d932673e632259220574",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397798",
      "title": "Private Patio or Balcony",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_3d82942bec4fb11122a059c6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397799",
      "title": "Garbage Disposal",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_dc8defacddb7569d6370bea0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397800",
      "title": "Window Coverings",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_74d88a6129ce62690d487b8d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397801",
      "title": "Air Conditioner",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "ec_0a3e3770a7ac0a47f6928ee3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "yardi",
      "external_id": "127397802",
      "title": "Preinstalled WiFi Modem Powered by Cox",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_4378b9ec-462f-483e-bc8f-1b205070b934",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-e815-74dc-b2c3-788753d3bb95.webp",
      "image_media": {
        "alt_text": "Cozy bedroom with a queen-size bed and plush bedding, featuring a nightstand with a lamp and a window with blinds.",
        "public_id": "019dcf6a-e815-74dc-b2c3-788753d3bb95",
        "storage_key": "property/6767906449165588/019dcf6a-e815-74dc-b2c3-788753d3bb95.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in comfort in this inviting bedroom, complete with a queen-size bed dressed in soft, warm-toned linens and decorative pillows. A stylish nightstand with a modern lamp adds functionality and ambiance.",
      "link": "",
      "alt_text": "Cozy bedroom with a queen-size bed and plush bedding, featuring a nightstand with a lamp and a window with blinds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_279037b2-2e05-4342-b693-cf6f7250d40d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-e0ce-706f-becc-0a0d5cc120f9.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with a sink, countertop, mirror, and storage cabinets.",
        "public_id": "019dcf6a-e0ce-706f-becc-0a0d5cc120f9",
        "storage_key": "property/6767906449165588/019dcf6a-e0ce-706f-becc-0a0d5cc120f9.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Stylish bathroom vanity featuring a spacious countertop, modern sink, and ample storage with cabinets and drawers.",
      "link": "",
      "alt_text": "Bathroom vanity with a sink, countertop, mirror, and storage cabinets.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_f2d30f05-0627-431a-8349-c51dbf633708",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-d81d-7549-b4b2-53dc9ecde9e8.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
        "public_id": "019dcf6a-d81d-7549-b4b2-53dc9ecde9e8",
        "storage_key": "property/6767906449165588/019dcf6a-d81d-7549-b4b2-53dc9ecde9e8.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "This apartment kitchen features sleek dark wood cabinetry, a full suite of black appliances including a microwave and stove, and durable granite countertops.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, black appliances, and granite countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d2f7e3d6-4d82-4289-b0db-6c6425750bf5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-d7be-76af-b389-b64b4f2729fd.webp",
      "image_media": {
        "alt_text": "Modern bathroom with vanity, toilet, and shower/tub combo.",
        "public_id": "019dcf6a-d7be-76af-b389-b64b4f2729fd",
        "storage_key": "property/6767906449165588/019dcf6a-d7be-76af-b389-b64b4f2729fd.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Refresh and relax in this modern bathroom, complete with a spacious vanity, toilet, and a shower/tub combination for your convenience.",
      "link": "",
      "alt_text": "Modern bathroom with vanity, toilet, and shower/tub combo.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1f2e05ff-b701-45b8-ba5a-cbb0c5dbbe7b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-d3e6-74ad-8cd8-864c38810a0c.webp",
      "image_media": {
        "alt_text": "Closet with washer and dryer hookups",
        "public_id": "019dcf6a-d3e6-74ad-8cd8-864c38810a0c",
        "storage_key": "property/6767906449165588/019dcf6a-d3e6-74ad-8cd8-864c38810a0c.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Convenient in-unit laundry closet with hookups for a washer and dryer.",
      "link": "",
      "alt_text": "Closet with washer and dryer hookups",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8916bf00-c067-44e1-8343-05c7ce8a6f56",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-cfef-703f-b722-e68f771a56d6.webp",
      "image_media": {
        "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a dual sink.",
        "public_id": "019dcf6a-cfef-703f-b722-e68f771a56d6",
        "storage_key": "property/6767906449165588/019dcf6a-cfef-703f-b722-e68f771a56d6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Modern kitchen featuring dark wood cabinetry, granite-style countertops, stainless steel appliances, and a spacious double sink. Perfect for preparing meals.",
      "link": "",
      "alt_text": "Kitchen with dark wood cabinets, granite countertops, stainless steel appliances, and a dual sink.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_781bce2d-425c-4ad9-a1c6-e79b6f661a70",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-c691-73af-b19c-d62bbfa6950f.webp",
      "image_media": {
        "alt_text": "View of a sparkling swimming pool from a private balcony with a ceiling fan.",
        "public_id": "019dcf6a-c691-73af-b19c-d62bbfa6950f",
        "storage_key": "property/6767906449165588/019dcf6a-c691-73af-b19c-d62bbfa6950f.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our community's outdoor swimming pool, perfect for relaxing on sunny days. This amenity is visible from your private balcony.",
      "link": "",
      "alt_text": "View of a sparkling swimming pool from a private balcony with a ceiling fan.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_30ab1b54-6a69-461c-ac5f-082074ada6db",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-cccd-7225-8c2b-baba51ef65c7.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark wood cabinets, stainless steel sink, black refrigerator and stove.",
        "public_id": "019dcf6a-cccd-7225-8c2b-baba51ef65c7",
        "storage_key": "property/6767906449165588/019dcf6a-cccd-7225-8c2b-baba51ef65c7.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Renovated kitchen featuring ample cabinet space, a full suite of black appliances including a refrigerator, stove, and microwave, and a stylish neutral-toned flooring.",
      "link": "",
      "alt_text": "Modern kitchen with dark wood cabinets, stainless steel sink, black refrigerator and stove.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d95e6218-3b6c-4db6-a2ce-5df54836de4f",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-cdfb-77df-bd12-1d34688e1b25.webp",
      "image_media": {
        "alt_text": "Dining area and kitchen with dark wood cabinets and stainless steel appliances.",
        "public_id": "019dcf6a-cdfb-77df-bd12-1d34688e1b25",
        "storage_key": "property/6767906449165588/019dcf6a-cdfb-77df-bd12-1d34688e1b25.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy meals in the dining area, adjacent to the fully equipped kitchen featuring dark wood cabinetry and modern appliances.",
      "link": "",
      "alt_text": "Dining area and kitchen with dark wood cabinets and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_88407a46-3014-4522-bc32-eedc8d335f1e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-c6bd-7480-be62-cfe4551bad07.webp",
      "image_media": {
        "alt_text": "Living room with a white sofa, coffee table, and abstract art.",
        "public_id": "019dcf6a-c6bd-7480-be62-cfe4551bad07",
        "storage_key": "property/6767906449165588/019dcf6a-c6bd-7480-be62-cfe4551bad07.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Bright and airy living room featuring a comfortable sofa, a stylish coffee table, and decorative art. A sliding glass door leads to a balcony with a view of the community pool.",
      "link": "",
      "alt_text": "Living room with a white sofa, coffee table, and abstract art.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a84bc03e-6c50-46d9-b2e8-871658fc410a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-c56d-7028-a512-f2283fef9891.webp",
      "image_media": {
        "alt_text": "Living room with fireplace and dining area.",
        "public_id": "019dcf6a-c56d-7028-a512-f2283fef9891",
        "storage_key": "property/6767906449165588/019dcf6a-c56d-7028-a512-f2283fef9891.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace and a bright dining area.",
      "link": "",
      "alt_text": "Living room with fireplace and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a717c159-180d-499f-a02e-be66e56a9a7e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-b7c0-74e5-bdc5-3bf8133c4d96.webp",
      "image_media": {
        "alt_text": "Business center with computers and printer",
        "public_id": "019dcf6a-b7c0-74e5-bdc5-3bf8133c4d96",
        "storage_key": "property/6767906449165588/019dcf6a-b7c0-74e5-bdc5-3bf8133c4d96.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Stay connected in our convenient business center, equipped with computers and a printer for all your work needs.",
      "link": "",
      "alt_text": "Business center with computers and printer",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eba7ca1f-da70-468d-96a9-672ead50f0cf",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-b617-7175-a0c7-26386d0178f2.webp",
      "image_media": {
        "alt_text": "Kitchen area with bar seating and a refrigerator.",
        "public_id": "019dcf6a-b617-7175-a0c7-26386d0178f2",
        "storage_key": "property/6767906449165588/019dcf6a-b617-7175-a0c7-26386d0178f2.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Enjoy a stylish kitchen with ample counter space, bar seating for casual dining, and modern appliances.",
      "link": "",
      "alt_text": "Kitchen area with bar seating and a refrigerator.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_cd2d76b1-21e2-4c28-a220-ec990ae06d19",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-b376-70ef-bb5b-10699b73d6b6.webp",
      "image_media": {
        "alt_text": "Lobby area with comfortable seating and a large TV.",
        "public_id": "019dcf6a-b376-70ef-bb5b-10699b73d6b6",
        "storage_key": "property/6767906449165588/019dcf6a-b376-70ef-bb5b-10699b73d6b6.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our inviting lobby, featuring plush seating and entertainment options.",
      "link": "",
      "alt_text": "Lobby area with comfortable seating and a large TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_8f5d0c71-c569-4a6d-8268-33307b4c30c0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-a308-7147-a457-6c91f806e72b.webp",
      "image_media": {
        "alt_text": "Empty walk-in closet with shelves and hanging rods",
        "public_id": "019dcf6a-a308-7147-a457-6c91f806e72b",
        "storage_key": "property/6767906449165588/019dcf6a-a308-7147-a457-6c91f806e72b.webp",
        "width": 2048,
        "height": 3072
      },
      "title": "Apartment",
      "description": "Spacious walk-in closet with built-in shelving and ample hanging space, perfect for organizing your belongings.",
      "link": "",
      "alt_text": "Empty walk-in closet with shelves and hanging rods",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_1ba0384b-2190-487f-a37c-7d4519fb3d95",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-b938-77a9-9974-bb6d914b344b.webp",
      "image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019dcf6a-b938-77a9-9974-bb6d914b344b",
        "storage_key": "property/6767906449165588/019dcf6a-b938-77a9-9974-bb6d914b344b.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Cozy living room featuring a fireplace, a stylish coffee table, and comfortable seating, perfect for relaxing evenings.",
      "link": "",
      "alt_text": "Living room with a fireplace, coffee table, and sofa.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_84c86be6-283d-4bee-b8fb-ed48646b33a2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-a368-75f9-9e5d-5843d3153217.webp",
      "image_media": {
        "alt_text": "Modern community lounge with a fireplace, plush seating, and a computer station.",
        "public_id": "019dcf6a-a368-75f9-9e5d-5843d3153217",
        "storage_key": "property/6767906449165588/019dcf6a-a368-75f9-9e5d-5843d3153217.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and connect in our stylish community lounge, featuring a cozy fireplace, comfortable seating, and a convenient computer area for residents.",
      "link": "",
      "alt_text": "Modern community lounge with a fireplace, plush seating, and a computer station.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d0b8dd63-931b-4787-bd0f-741725425831",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-a1d7-7040-8f4d-95f557641f93.webp",
      "image_media": {
        "alt_text": "Spacious communal lounge area with a fireplace, large sectional sofas, dining area, and a TV.",
        "public_id": "019dcf6a-a1d7-7040-8f4d-95f557641f93",
        "storage_key": "property/6767906449165588/019dcf6a-a1d7-7040-8f4d-95f557641f93.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Community",
      "description": "Relax and unwind in our beautifully appointed communal lounge, featuring a cozy fireplace, comfortable seating, and a dining area perfect for gatherings.",
      "link": "",
      "alt_text": "Spacious communal lounge area with a fireplace, large sectional sofas, dining area, and a TV.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_71fceeb5-36da-4e05-988e-cb2bd6bcb79c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf6a-9f9b-734e-89ee-4290c2e700d0.webp",
      "image_media": {
        "alt_text": "Bedroom with a wooden headboard, pink and orange bedding, and a walk-in closet.",
        "public_id": "019dcf6a-9f9b-734e-89ee-4290c2e700d0",
        "storage_key": "property/6767906449165588/019dcf6a-9f9b-734e-89ee-4290c2e700d0.webp",
        "width": 2700,
        "height": 1800
      },
      "title": "Apartment",
      "description": "Relax in this comfortable bedroom, featuring a cozy bed with stylish linens and ample storage space in the walk-in closet.",
      "link": "",
      "alt_text": "Bedroom with a wooden headboard, pink and orange bedding, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b1e7da5a-3b66-4c5b-88b4-c9e8323c4b08",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-6c1c-70c5-937c-9eeac7dddc5b.webp",
      "image_media": {
        "alt_text": "Apartment buildings exterior with a view of the outdoor swimming pool area.",
        "public_id": "019dcf69-6c1c-70c5-937c-9eeac7dddc5b",
        "storage_key": "property/6767906449165588/019dcf69-6c1c-70c5-937c-9eeac7dddc5b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy the sun and relaxation at our sparkling outdoor swimming pool, surrounded by comfortable seating and lush landscaping. A perfect spot to unwind and soak up the rays.",
      "link": "",
      "alt_text": "Apartment buildings exterior with a view of the outdoor swimming pool area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_abc19acf-2196-4c12-97c2-6477bd4dac42",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-663c-73cf-8b3b-66712affbf1a.webp",
      "image_media": {
        "alt_text": "Exterior view of apartment buildings with walkways and green spaces.",
        "public_id": "019dcf69-663c-73cf-8b3b-66712affbf1a",
        "storage_key": "property/6767906449165588/019dcf69-663c-73cf-8b3b-66712affbf1a.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Winding walkways and lush green courtyards connect the charming apartment buildings, offering a peaceful and inviting community atmosphere.",
      "link": "",
      "alt_text": "Exterior view of apartment buildings with walkways and green spaces.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4213a39f-5f5c-49b0-a5ff-2ded57af1c7a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-5e74-765d-ad7b-9d4fa6d64cb4.webp",
      "image_media": {
        "alt_text": "Sidewalk path between apartment buildings with green grass and stone retaining wall.",
        "public_id": "019dcf69-5e74-765d-ad7b-9d4fa6d64cb4",
        "storage_key": "property/6767906449165588/019dcf69-5e74-765d-ad7b-9d4fa6d64cb4.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Walk along the scenic path connecting our apartment buildings, surrounded by lush greenery and charming stone accents.",
      "link": "",
      "alt_text": "Sidewalk path between apartment buildings with green grass and stone retaining wall.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_4ffa8d2c-7c42-49fd-baa6-1300e97ac0ac",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-592c-7666-be71-0e81b05799d1.webp",
      "image_media": {
        "alt_text": "Exterior walkway between apartment buildings with landscaping and trees.",
        "public_id": "019dcf69-592c-7666-be71-0e81b05799d1",
        "storage_key": "property/6767906449165588/019dcf69-592c-7666-be71-0e81b05799d1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Walkway leading through the landscaped grounds between apartment buildings. Enjoy a serene outdoor environment.",
      "link": "",
      "alt_text": "Exterior walkway between apartment buildings with landscaping and trees.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_eb096918-944c-4f16-9bdf-ae348612aeed",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-55c8-7588-989b-ca4e5eb72fe1.webp",
      "image_media": {
        "alt_text": "Cedar Glade apartment complex monument sign",
        "public_id": "019dcf69-55c8-7588-989b-ca4e5eb72fe1",
        "storage_key": "property/6767906449165588/019dcf69-55c8-7588-989b-ca4e5eb72fe1.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Cedar Glade, a premier apartment community. This monument sign provides a clear indication of the property's name and leasing information.",
      "link": "",
      "alt_text": "Cedar Glade apartment complex monument sign",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_a88a8f7f-224e-4ff6-90cc-5cc0191eef33",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-23e8-73bb-b192-27c7dfee0edc.webp",
      "image_media": {
        "alt_text": "Cedar Glade Leasing Center entrance with stairs and landscaping.",
        "public_id": "019dcf69-23e8-73bb-b192-27c7dfee0edc",
        "storage_key": "property/6767906449165588/019dcf69-23e8-73bb-b192-27c7dfee0edc.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the Cedar Glade Leasing Center, where you can explore our community and find your perfect home. Self-guided tours are available.",
      "link": "",
      "alt_text": "Cedar Glade Leasing Center entrance with stairs and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_7d131c2b-adff-4470-a2e1-d0a0b2abe0c8",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-33d2-7211-8321-2802a70d4b40.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and building in the background.",
        "public_id": "019dcf69-33d2-7211-8321-2802a70d4b40",
        "storage_key": "property/6767906449165588/019dcf69-33d2-7211-8321-2802a70d4b40.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by comfortable lounge chairs and lush landscaping.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and building in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_83ee3cf5-5b18-48bf-aeeb-9c073fdf7d40",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-2246-7409-98b5-19bb033fec41.webp",
      "image_media": {
        "alt_text": "Cedar Glade Leasing Center entrance with a modern design and landscaping.",
        "public_id": "019dcf69-2246-7409-98b5-19bb033fec41",
        "storage_key": "property/6767906449165588/019dcf69-2246-7409-98b5-19bb033fec41.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to the Cedar Glade Leasing Center. Experience our modern design and beautiful landscaping as you explore our community.",
      "link": "",
      "alt_text": "Cedar Glade Leasing Center entrance with a modern design and landscaping.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_d3c62806-35e0-4049-8ff2-42dbe40edd82",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-3c72-77cb-af90-c02742c1d770.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and a gazebo at an apartment complex.",
        "public_id": "019dcf69-3c72-77cb-af90-c02742c1d770",
        "storage_key": "property/6767906449165588/019dcf69-3c72-77cb-af90-c02742c1d770.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our beautiful outdoor swimming pool, surrounded by comfortable lounge chairs and a charming gazebo for shaded relaxation.",
      "link": "",
      "alt_text": "Sparkling swimming pool with lounge chairs and a gazebo at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_6782a079-7a44-47f2-9870-7a3a5b1a886c",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-3c71-747d-9597-7c09c2cce425.webp",
      "image_media": {
        "alt_text": "Swimming pool with lounge chairs and a covered seating area at an apartment complex.",
        "public_id": "019dcf69-3c71-747d-9597-7c09c2cce425",
        "storage_key": "property/6767906449165588/019dcf69-3c71-747d-9597-7c09c2cce425.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in the sparkling swimming pool, surrounded by comfortable lounge chairs and a shaded pavilion for relaxation.",
      "link": "",
      "alt_text": "Swimming pool with lounge chairs and a covered seating area at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_2905696d-4333-47c0-bb80-8aef423f9889",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-20b2-73c8-80db-724db13fec3b.webp",
      "image_media": {
        "alt_text": "Resort-style swimming pool with lounge chairs and a gazebo at an apartment complex.",
        "public_id": "019dcf69-20b2-73c8-80db-724db13fec3b",
        "storage_key": "property/6767906449165588/019dcf69-20b2-73c8-80db-724db13fec3b.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, perfect for relaxing and soaking up the sun. Lounge chairs and a shaded gazebo provide comfort and convenience for all residents.",
      "link": "",
      "alt_text": "Resort-style swimming pool with lounge chairs and a gazebo at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_27466e90-8264-4122-8bec-d3673ade693a",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019dcf69-1f2f-708c-b39a-57f3bc66d1fd.webp",
      "image_media": {
        "alt_text": "Exterior view of the Cedar Glade leasing center with green siding and a covered entrance.",
        "public_id": "019dcf69-1f2f-708c-b39a-57f3bc66d1fd",
        "storage_key": "property/6767906449165588/019dcf69-1f2f-708c-b39a-57f3bc66d1fd.webp",
        "width": 3072,
        "height": 2048
      },
      "title": "Community",
      "description": "Welcome to Cedar Glade's leasing center. Exterior view showcasing the property's charm and accessible entrance.",
      "link": "",
      "alt_text": "Exterior view of the Cedar Glade leasing center with green siding and a covered entrance.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_901572a8-b118-4ed7-9957-0a41e39a7953",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d4eb4-ee8a-7142-b090-8132e6760ddb.webp",
      "image_media": {
        "alt_text": "Outdoor swimming pool with lounge chairs and a table with umbrella.",
        "public_id": "019d4eb4-ee8a-7142-b090-8132e6760ddb",
        "storage_key": "property/6767906449165588/019d4eb4-ee8a-7142-b090-8132e6760ddb.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Relax by the sparkling outdoor swimming pool, complete with comfortable lounge chairs and a shaded seating area for dining or socializing.",
      "link": "",
      "alt_text": "Outdoor swimming pool with lounge chairs and a table with umbrella.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    },
    {
      "id": "custom_b587cd65-16de-4fb0-8b41-410be6f71a0e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d4eb4-aaeb-7347-9b76-6a574a10284e.webp",
      "image_media": {
        "alt_text": "Fitness center with treadmills, elliptical, and weight machine.",
        "public_id": "019d4eb4-aaeb-7347-9b76-6a574a10284e",
        "storage_key": "property/6767906449165588/019d4eb4-aaeb-7347-9b76-6a574a10284e.webp",
        "width": 2048,
        "height": 1365
      },
      "title": "Community",
      "description": "Stay active in our fully-equipped fitness center, featuring treadmills, an elliptical, and a versatile weight machine.",
      "link": "",
      "alt_text": "Fitness center with treadmills, elliptical, and weight machine.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": "false"
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_74c1d0f3-ac6a-4bf9-9d72-c117940c6409",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Texas Roadhouse",
      "poi_type": "Restaurants",
      "poi_address": "11111 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain steakhouse known for its hand-cut steaks, ribs, and made-from-scratch sides.",
      "poi_long_description": "People say this steakhouse serves delicious steaks, ribs, and filet medallions, and their rolls with cinnamon butter are a highlight. They also highlight the affordable prices, fun atmosphere, and attentive service.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-bc12-74ca-80a5-a9b2f0d56498.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bc12-74ca-80a5-a9b2f0d56498",
        "storage_key": "property/6767906449165588/019d2708-bc12-74ca-80a5-a9b2f0d56498.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.texasroadhouse.com/locations/oklahoma/tulsa-east-71st-st?utm_source=listing&utm_medium=search",
      "poi_directions_map_url": "https://maps.google.com/?cid=10669544637791228065&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "texas-roadhouse",
      "poi_latitude": "36.0613876",
      "poi_longitude": "-95.852648",
      "poi_miles_from_property": "1.2",
      "poi_walking_minutes": "26 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-461-8891",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f5ec-7194-ae54-944ccb8abbd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f5ec-7194-ae54-944ccb8abbd0",
        "storage_key": "property/6767906449165588/019d2708-f5ec-7194-ae54-944ccb8abbd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ6dEXckyMtocRoVC4glHWEZQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "steak_house"
    },
    {
      "id": "custom_246d991d-8caf-410b-ac24-c584ad2cb437",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "The Cheesecake Factory",
      "poi_type": "Restaurants",
      "poi_address": "8711 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "American chain restaurant offering sizable portions from a vast menu including signature cheesecake",
      "poi_long_description": "People say this restaurant offers a diverse menu with delicious pasta, burgers, and cheesecake. They also highlight the attentive and friendly service, and the warm and welcoming atmosphere, ideal for a casual yet elevated evening out.\n\nOther reviews mention the food can be overpriced.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-bb69-76d5-9cca-cda20ae14cbf.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bb69-76d5-9cca-cda20ae14cbf",
        "storage_key": "property/6767906449165588/019d2708-bb69-76d5-9cca-cda20ae14cbf.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.thecheesecakefactory.com/ok/tulsa-130.html?utm_source=Google&utm_medium=Maps&utm_campaign=Google+Places",
      "poi_directions_map_url": "https://maps.google.com/?cid=16222748060775136545&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "the-cheesecake-factory",
      "poi_latitude": "36.0614349",
      "poi_longitude": "-95.8795591",
      "poi_miles_from_property": "1.1",
      "poi_walking_minutes": "24 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-249-2300",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f5ec-7194-ae54-944ccb8abbd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f5ec-7194-ae54-944ccb8abbd0",
        "storage_key": "property/6767906449165588/019d2708-f5ec-7194-ae54-944ccb8abbd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJbxJhQ5aNtocRIb0o02jHIuE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_4c1b34a8-92a7-4219-aeb8-423cedbc0baa",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Raising Cane's Chicken Fingers",
      "poi_type": "Restaurants",
      "poi_address": "4810 S Yale Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Casual chain, known for battered chicken fingers, fries, Texas toast and signature sauce, as well as friendly service.",
      "poi_long_description": "People say this fast food restaurant serves delicious chicken fingers and a tasty dipping sauce. They highlight the fair pricing and generous portions. They also like the fast and friendly service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-bb2f-746d-bd77-63e31538ac30.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bb2f-746d-bd77-63e31538ac30",
        "storage_key": "property/6767906449165588/019d2708-bb2f-746d-bd77-63e31538ac30.webp",
        "width": 720,
        "height": 720
      },
      "poi_business_url": "https://locations.raisingcanes.com/ok/tulsa/4810-s.-yale-avenue",
      "poi_directions_map_url": "https://maps.google.com/?cid=6097855623742206873&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "raising-canes-chicken-fingers",
      "poi_latitude": "36.0929086",
      "poi_longitude": "-95.9228346",
      "poi_miles_from_property": "5.3",
      "poi_walking_minutes": "1 hour 59 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-477-9354",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f5ec-7194-ae54-944ccb8abbd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f5ec-7194-ae54-944ccb8abbd0",
        "storage_key": "property/6767906449165588/019d2708-f5ec-7194-ae54-944ccb8abbd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW0uXiuqStocRmbPFyGHvn1Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_7d5eeedf-96b5-47a6-85af-d7e8db9ea341",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Chick-fil-A",
      "poi_type": "Restaurants",
      "poi_address": "4933 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Popular fast-food chain specializing in chicken sandwiches and nuggets.",
      "poi_long_description": "People say this fast food restaurant serves fresh food. They also highlight the friendly staff and fast service.\n\nOther reviews mention the drive-thru can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-bb39-73b9-a129-6ad8e30d08d5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-bb39-73b9-a129-6ad8e30d08d5",
        "storage_key": "property/6767906449165588/019d2708-bb39-73b9-a129-6ad8e30d08d5.webp",
        "width": 1069,
        "height": 1280
      },
      "poi_business_url": "https://www.chick-fil-a.com/locations/ok/southroads-shopping-center?utm_source=yext&utm_medium=link",
      "poi_directions_map_url": "https://maps.google.com/?cid=13411138926925396352&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "chick-fil-a",
      "poi_latitude": "36.1047058",
      "poi_longitude": "-95.919763",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 16 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-622-7815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f5ec-7194-ae54-944ccb8abbd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f5ec-7194-ae54-944ccb8abbd0",
        "storage_key": "property/6767906449165588/019d2708-f5ec-7194-ae54-944ccb8abbd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJW6nzsMeStocRgDnNfMzvHbo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_9db2888f-f8d2-46cf-be2b-712fd4cde4fb",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Cheddar's Scratch Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10708 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly national chain serving classic American comfort foods, plus cocktails, beer and steaks.",
      "poi_long_description": "Diners say this traditional US American restaurant serves up delicious honey butter croissants, salmon, and steak. They also highlight the friendly and attentive service, reasonable prices, and generous portions.\n\nSome reviews mention the wait times can be long.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-c136-72de-a3c2-594299f7c6ad.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c136-72de-a3c2-594299f7c6ad",
        "storage_key": "property/6767906449165588/019d2708-c136-72de-a3c2-594299f7c6ad.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cheddars.com/locations/ok/tulsa/tulsa/2015?cmpid=br:csk_ag:ie_ch:loc_ca:CSKGMB_sn:gmb_gt:tulsa-ok-2015_pl:locurl_rd:1010",
      "poi_directions_map_url": "https://maps.google.com/?cid=11101010613821228024&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cheddars-scratch-kitchen",
      "poi_latitude": "36.06025",
      "poi_longitude": "-95.85707",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "20 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-307-2013",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f5ec-7194-ae54-944ccb8abbd0.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f5ec-7194-ae54-944ccb8abbd0",
        "storage_key": "property/6767906449165588/019d2708-f5ec-7194-ae54-944ccb8abbd0.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJM6XrprSNtocR-MOnbFa2Dpo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_32406c83-54e5-4bfa-8ca8-7ba400163494",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Woodland Hills Mall",
      "poi_type": "Shopping & Retail",
      "poi_address": "7021 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Spacious, clean, 2-level shopping center featuring a carousel for kids as well as a variety of food options.",
      "poi_long_description": "Visitors say this shopping center has a wide variety of stores, including Scheels, Macy's, Dillard's, and JCPenney, and a great food court with many options. They also highlight the clean, safe, and friendly atmosphere, and the family-friendly environment with activities for children.\n\nSome reviews mention the escalators can be out of order.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-c13a-77d7-ade7-83e94b4eebd5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c13a-77d7-ade7-83e94b4eebd5",
        "storage_key": "property/6767906449165588/019d2708-c13a-77d7-ade7-83e94b4eebd5.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.simon.com/mall/woodland-hills-mall",
      "poi_directions_map_url": "https://maps.google.com/?cid=6466318501171358790&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "woodland-hills-mall",
      "poi_latitude": "36.063341",
      "poi_longitude": "-95.881655",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-250-1449",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f61c-72be-93a4-e84907b367db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f61c-72be-93a4-e84907b367db",
        "storage_key": "property/6767906449165588/019d2708-f61c-72be-93a4-e84907b367db.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ8fv_EJeNtocRRuzasmr6vFk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_17be2475-16ca-4e8a-a53a-d155ad2e6d7a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Tulsa Premium Outlets",
      "poi_type": "Shopping & Retail",
      "poi_address": "801 E Outlet Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Clean outdoor mall offering discounts on designer wares and home goods, plus a playground.",
      "poi_long_description": "People say this outlet mall offers a wide variety of stores with great deals and discounts. They highlight the clean, spacious, and welcoming atmosphere, as well as the convenient layout and ample parking. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-c316-74df-a8a0-9f0cb6bfcb28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c316-74df-a8a0-9f0cb6bfcb28",
        "storage_key": "property/6767906449165588/019d2708-c316-74df-a8a0-9f0cb6bfcb28.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "https://www.premiumoutlets.com/outlet/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17542502898214519848&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-premium-outlets",
      "poi_latitude": "36.0147952",
      "poi_longitude": "-95.962744",
      "poi_miles_from_property": "7.9",
      "poi_walking_minutes": "2 hours 54 mins",
      "poi_biking_minutes": "50 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-528-8940",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f61c-72be-93a4-e84907b367db.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f61c-72be-93a4-e84907b367db",
        "storage_key": "property/6767906449165588/019d2708-f61c-72be-93a4-e84907b367db.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi_O0gRORtocRKERWF3F9c_M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_e26c0ecb-4565-4722-b8b2-a516b5cd6a25",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "WinCo Foods",
      "poi_type": "Shopping & Retail",
      "poi_address": "7130 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Food mart stocking meat, baked goods and household staples, plus bulk bins.",
      "poi_long_description": "Shoppers say this grocery store offers great savings on a wide variety of items, including bulk goods like candy, nuts, and spices, as well as fresh produce and quality meats. They also highlight the store's 24/7 accessibility, reasonable prices, and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-c160-77cf-ad71-fe740b7fe2a0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c160-77cf-ad71-fe740b7fe2a0",
        "storage_key": "property/6767906449165588/019d2708-c160-77cf-ad71-fe740b7fe2a0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.wincofoods.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8053298412458330468&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "winco-foods",
      "poi_latitude": "36.0597141",
      "poi_longitude": "-95.8890336",
      "poi_miles_from_property": "1.6",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-888-7002",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f61a-7569-9a2e-8bc06e728af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f61a-7569-9a2e-8bc06e728af4",
        "storage_key": "property/6767906449165588/019d2708-f61a-7569-9a2e-8bc06e728af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ62eScyGNtocRZMnL6DwQw28",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_66ad1a0c-7010-4db8-a135-74357a6ad295",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Pan-Asia Supermarket",
      "poi_type": "Shopping & Retail",
      "poi_address": "10003 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Asian grocery store featuring fresh produce and seafood. Also on offer: sushi and tea.",
      "poi_long_description": "People say this Asian grocery store offers a wide variety of fresh produce, live seafood, and Asian groceries, including a large selection of meats, spices, and noodles. They highlight the fair prices, the clean and organized store, and the delicious hot food, boba tea, and sushi available at the cafe. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-c5f6-737d-8b31-253c88a8e991.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c5f6-737d-8b31-253c88a8e991",
        "storage_key": "property/6767906449165588/019d2708-c5f6-737d-8b31-253c88a8e991.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.panasiasupermarket.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1484729550679765321&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "pan-asia-supermarket",
      "poi_latitude": "36.0630212",
      "poi_longitude": "-95.8655271",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-940-7570",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f61a-7569-9a2e-8bc06e728af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f61a-7569-9a2e-8bc06e728af4",
        "storage_key": "property/6767906449165588/019d2708-f61a-7569-9a2e-8bc06e728af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJP1gpIX6NtocRSfHK76jRmhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_158309ec-fd76-4148-ba94-ee9a4613049f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "9136 S Yale Ave, Tulsa, OK 74137, USA",
      "poi_short_description": "Market selling organic produce and gluten-free grocery items.",
      "poi_long_description": "People say this grocery store offers a wide selection of healthy and organic foods, including fresh produce, a salad bar, and a variety of vitamins and supplements. They also highlight the clean and organized layout, the friendly and helpful staff, and the relaxed shopping experience.\n\nOther reviews mention the prices can be high.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-c863-71ac-a9d7-4de9a1b71b88.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c863-71ac-a9d7-4de9a1b71b88",
        "storage_key": "property/6767906449165588/019d2708-c863-71ac-a9d7-4de9a1b71b88.webp",
        "width": 1280,
        "height": 603
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/yale?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=4690334156598386947&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "36.030638",
      "poi_longitude": "-95.9237179",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 46 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 918-879-0493",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f61a-7569-9a2e-8bc06e728af4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f61a-7569-9a2e-8bc06e728af4",
        "storage_key": "property/6767906449165588/019d2708-f61a-7569-9a2e-8bc06e728af4.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJp2KYkCCStocRA6HtoRBqF0E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_e35e49e4-49d9-4b20-b371-7e2afe044194",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Oral Roberts University",
      "poi_type": "Education",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74171, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-c8f3-766c-ae1a-57efc4bfcc5d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c8f3-766c-ae1a-57efc4bfcc5d",
        "storage_key": "property/6767906449165588/019d2708-c8f3-766c-ae1a-57efc4bfcc5d.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://oru.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13173931362498967750&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oral-roberts-university",
      "poi_latitude": "36.0508093",
      "poi_longitude": "-95.9528284",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "57 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-495-6161",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f5f8-727b-bd7f-f16070a03d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f5f8-727b-bd7f-f16070a03d6e",
        "storage_key": "property/6767906449165588/019d2708-f5f8-727b-bd7f-f16070a03d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJdwdeD7iTtocRxvgglcY007Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_94dc182e-98ad-4e9f-8082-b52cd5da010b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Tulsa Community College Southeast Campus",
      "poi_type": "Education",
      "poi_address": "10300 E 81st St, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-c975-7214-b44e-e5de7dce6cca.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-c975-7214-b44e-e5de7dce6cca",
        "storage_key": "property/6767906449165588/019d2708-c975-7214-b44e-e5de7dce6cca.webp",
        "width": 1280,
        "height": 924
      },
      "poi_business_url": "https://www.tulsacc.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8389070837534418764&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "tulsa-community-college-southeast-campus",
      "poi_latitude": "36.0448034",
      "poi_longitude": "-95.8624934",
      "poi_miles_from_property": "1.3",
      "poi_walking_minutes": "28 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-595-7000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f5f8-727b-bd7f-f16070a03d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f5f8-727b-bd7f-f16070a03d6e",
        "storage_key": "property/6767906449165588/019d2708-f5f8-727b-bd7f-f16070a03d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJY1olEM6NtocRTOfTwnr3a3Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_595fa2ba-5305-44ed-a976-0f88c0b3240d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Hardesty Regional Library",
      "poi_type": "Education",
      "poi_address": "8316 E 93rd St, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed library featuring kids' sections (some with play areas and puzzles) plus meeting rooms and study space.",
      "poi_long_description": "People say this public library offers a wide selection of books, study rooms, and computers. They highlight the clean and safe environment, and the helpful staff. They also like the separate kids and adult sections, and the dedicated teen space. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-cd32-752d-bff9-ac8e5da445dd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-cd32-752d-bff9-ac8e5da445dd",
        "storage_key": "property/6767906449165588/019d2708-cd32-752d-bff9-ac8e5da445dd.webp",
        "width": 500,
        "height": 375
      },
      "poi_business_url": "http://www.tulsalibrary.org/hardesty",
      "poi_directions_map_url": "https://maps.google.com/?cid=3083775875462030879&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hardesty-regional-library",
      "poi_latitude": "36.0268456",
      "poi_longitude": "-95.8830539",
      "poi_miles_from_property": "3",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 918-549-7323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f5f8-727b-bd7f-f16070a03d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f5f8-727b-bd7f-f16070a03d6e",
        "storage_key": "property/6767906449165588/019d2708-f5f8-727b-bd7f-f16070a03d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKe3yqg6OtocRH2bV99HFyyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_28f5599a-8346-460d-9bd9-c856afde1fdd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "OU-Tulsa",
      "poi_type": "Education",
      "poi_address": "4502 E 41st St, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-cfd7-712b-809a-62852c80c91f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-cfd7-712b-809a-62852c80c91f",
        "storage_key": "property/6767906449165588/019d2708-cfd7-712b-809a-62852c80c91f.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "http://tulsa.ou.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=247462858016865972&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "ou-tulsa",
      "poi_latitude": "36.1024131",
      "poi_longitude": "-95.9259796",
      "poi_miles_from_property": "6.2",
      "poi_walking_minutes": "2 hours 18 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-660-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f5f8-727b-bd7f-f16070a03d6e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-f5f8-727b-bd7f-f16070a03d6e",
        "storage_key": "property/6767906449165588/019d2708-f5f8-727b-bd7f-f16070a03d6e.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJcz8INcGStocRtL4ygygqbwM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_21790262-f1f5-4f08-ac4d-3d1440ff53d4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Oklahoma Aquarium",
      "poi_type": "Entertainment",
      "poi_address": "300 Aquarium Dr, Jenks, OK 74037, USA",
      "poi_short_description": "Relaxed aquarium with sharks, river otters, turtles and jellyfish.",
      "poi_long_description": "People say this aquarium offers a wide variety of fish, including sharks, jellyfish, and an octopus, as well as interactive exhibits and touch tanks. They highlight the family-friendly atmosphere, the fun and educational experience, and the impressive shark tunnel and sea turtle exhibit. They also like the friendly and helpful staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-d03b-77ca-9630-d49d22a7e7fd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d03b-77ca-9630-d49d22a7e7fd",
        "storage_key": "property/6767906449165588/019d2708-d03b-77ca-9630-d49d22a7e7fd.webp",
        "width": 1280,
        "height": 878
      },
      "poi_business_url": "http://www.okaquarium.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13127406968110887214&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "oklahoma-aquarium",
      "poi_latitude": "36.0198841",
      "poi_longitude": "-95.9570456",
      "poi_miles_from_property": "7.4",
      "poi_walking_minutes": "2 hours 44 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-296-3474",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOcElRmSRtocRLrE85BXrLbY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "aquarium"
    },
    {
      "id": "custom_307c14cb-8c4e-4364-9a0b-e535fea64536",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Mabee Center",
      "poi_type": "Entertainment",
      "poi_address": "7777 S Lewis Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "Sprawling facility for concerts, basketball events and graduations, plus other events.",
      "poi_long_description": "Entertainment venue hosting nationally known performers, church services, sports & family events.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-d08a-70bb-bf19-f25d5412ce1d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d08a-70bb-bf19-f25d5412ce1d",
        "storage_key": "property/6767906449165588/019d2708-d08a-70bb-bf19-f25d5412ce1d.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "http://mabeecenter.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7042245147778354535&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mabee-center",
      "poi_latitude": "36.0480386",
      "poi_longitude": "-95.9557686",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "55 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuUFxgMeTtocRZw2MhqYUu2E",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "arena"
    },
    {
      "id": "custom_93f5ed89-c384-497b-bfe9-9704b7c5d800",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Urban Air Trampoline and Adventure Park",
      "poi_type": "Entertainment",
      "poi_address": "3328 E 51st St, Tulsa, OK 74135, USA",
      "poi_short_description": "Family-friendly chain featuring trampolines, climbing walls, ropes courses and other active recreational options.",
      "poi_long_description": "People say this amusement park offers a variety of activities, including trampolines, go-karts, zip lines, and virtual reality. They also highlight the helpful staff and the fun atmosphere for birthday parties.\n\nOther reviews mention the food can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-d21c-725b-86e4-2f7c02ae143b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d21c-725b-86e4-2f7c02ae143b",
        "storage_key": "property/6767906449165588/019d2708-d21c-725b-86e4-2f7c02ae143b.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.urbanair.com/oklahoma-tulsa/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=3062250087465279410&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "urban-air-trampoline-and-adventure-park",
      "poi_latitude": "36.0884996",
      "poi_longitude": "-95.9384116",
      "poi_miles_from_property": "6",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "34 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-770-9987",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ1wX9dvyTtocRst_G5DpMfyo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_1bfef8e4-0c7c-4b5d-be6e-f6c4dad6477b",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Sky Zone Trampoline Park",
      "poi_type": "Entertainment",
      "poi_address": "8306 E 61st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Gravity-defying entertainment venue with state-of-the-art trampolines, plus dodgeball courts.",
      "poi_long_description": "People say this amusement park offers fun trampolines, attractions, and a zip line. They also highlight the massage chairs for adults and the designated space for birthday parties.\n\nOther reviews mention the customer service can be inattentive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-d735-70c9-a91a-8804b741b00d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d735-70c9-a91a-8804b741b00d",
        "storage_key": "property/6767906449165588/019d2708-d735-70c9-a91a-8804b741b00d.webp",
        "width": 1280,
        "height": 718
      },
      "poi_business_url": "https://www.skyzone.com/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2967499010622421820&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "sky-zone-trampoline-park",
      "poi_latitude": "36.07405900000001",
      "poi_longitude": "-95.883873",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 918-877-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJM3PGwZ2NtocRPPt4r6CsLik",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_786644eb-f980-4a3b-99ab-7b8d17a499b8",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Slick City Action Park",
      "poi_type": "Entertainment",
      "poi_address": "5352 E Skelly Dr, Tulsa, OK 74135, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this amusement park offers a variety of fun slides, a basketball court, and a play area for younger children. They also highlight the friendly and helpful staff, and the clean and safe environment.\n\nOther reviews mention the concessions can be expensive.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-d731-701a-8b73-2b917f800fa9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d731-701a-8b73-2b917f800fa9",
        "storage_key": "property/6767906449165588/019d2708-d731-701a-8b73-2b917f800fa9.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://slickcity.com/ok-tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12324602171454774354&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "slick-city-action-park",
      "poi_latitude": "36.0979811",
      "poi_longitude": "-95.9157069",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 5 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-818-7423",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJFytTvJWTtocRUtyRW2DICas",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_park"
    },
    {
      "id": "custom_976c12a7-876d-4263-a561-d8be61cf7f58",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Life Time",
      "poi_type": "Health and Wellness",
      "poi_address": "10642 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Athletic country club featuring indoor and outdoor pools, yoga classes, and basketball and pickleball courts, plus a cafe.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-d725-705c-9a5d-30f0dfda0867.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d725-705c-9a5d-30f0dfda0867",
        "storage_key": "property/6767906449165588/019d2708-d725-705c-9a5d-30f0dfda0867.webp",
        "width": 640,
        "height": 640
      },
      "poi_business_url": "https://www.lifetime.life/locations/ok/south-tulsa.html?utm_source=google&utm_medium=local&utm_campaign=google-local-club",
      "poi_directions_map_url": "https://maps.google.com/?cid=3628922520137756888&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "life-time",
      "poi_latitude": "36.0093414",
      "poi_longitude": "-95.8899718",
      "poi_miles_from_property": "4.4",
      "poi_walking_minutes": "1 hour 37 mins",
      "poi_biking_minutes": "25 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-364-8500",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJEwVCKhaOtocR2PA5Is6FXDI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_b1e6438e-3afb-4410-9e62-08debf48b049",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Crunch Fitness - Tulsa",
      "poi_type": "Health and Wellness",
      "poi_address": "7827 E 91st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Friendly gym, fitness-oriented chain, featuring cardio equipment, group classes, and personal-training services.",
      "poi_long_description": "People say this gym offers a wide variety of equipment and group classes, and has a clean facility with helpful and knowledgeable staff.\n\nOther reviews mention the membership cancellation process can be difficult and the gym can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-d8f2-70e7-86a9-502fd9083b69.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-d8f2-70e7-86a9-502fd9083b69",
        "storage_key": "property/6767906449165588/019d2708-d8f2-70e7-86a9-502fd9083b69.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=3614973288206348263&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---tulsa",
      "poi_latitude": "36.0337164",
      "poi_longitude": "-95.8883964",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 539-842-0966",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB747NHCNtocR568QfA33KjI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d3bc01ef-6b31-41ce-b43f-f1802514adb1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Crunch Fitness - Broken Arrow",
      "poi_type": "Health and Wellness",
      "poi_address": "3701 S Elm Pl, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Gym offering fitness classes, cardio equipment, and personal training, plus tanning.",
      "poi_long_description": "People say this gym offers a wide variety of well-maintained equipment and machines. They also highlight the friendly and helpful staff, and the clean and spacious facility.\n\nOther reviews mention the music can be loud.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-dc89-76ab-bda2-674294092992.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dc89-76ab-bda2-674294092992",
        "storage_key": "property/6767906449165588/019d2708-dc89-76ab-bda2-674294092992.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.crunch.com/locations/brokenarrow",
      "poi_directions_map_url": "https://maps.google.com/?cid=7237271301754615382&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "crunch-fitness---broken-arrow",
      "poi_latitude": "36.0152872",
      "poi_longitude": "-95.7956716",
      "poi_miles_from_property": "7",
      "poi_walking_minutes": "2 hours 33 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 918-395-5070",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0wtAG4WJtocRVnY2fOfzb2Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_2c5c8428-fc41-4ac6-9a8f-46cf31567b36",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "8405 E 91st Pl, Tulsa, OK 74133, USA",
      "poi_short_description": "Relaxed, chain gym featuring free weights, massage chairs and tanning beds, plus classes.",
      "poi_long_description": "Gym goers say this gym offers a clean and tidy facility with a welcoming and judgement-free atmosphere, and they appreciate the friendly and helpful staff. They also highlight the great price and smooth interaction with other members.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-dd70-71e9-85ca-fbefd98c8a07.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dd70-71e9-85ca-fbefd98c8a07",
        "storage_key": "property/6767906449165588/019d2708-dd70-71e9-85ca-fbefd98c8a07.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/south-tulsa-ok?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=294788399712763127&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "36.0326146",
      "poi_longitude": "-95.8832595",
      "poi_miles_from_property": "2.6",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 539-664-7592",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJu58mAgqOtocR9_zI2HxMFwQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_4275eff2-6f4a-4cb0-99d5-f97e2d4f7c3e",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "iidentity salon",
      "poi_type": "Health and Wellness",
      "poi_address": "2731 S Harvard Ave, Tulsa, OK 74114, USA",
      "poi_short_description": "Hair styling salon with a friendly staff and a warm atmosphere, offering cuts and coloring services.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-dd6a-74a8-9fdd-18f171dfae26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-dd6a-74a8-9fdd-18f171dfae26",
        "storage_key": "property/6767906449165588/019d2708-dd6a-74a8-9fdd-18f171dfae26.webp",
        "width": 960,
        "height": 893
      },
      "poi_business_url": "http://www.iidentitysalon.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=9820300745508314431&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "iidentity-salon",
      "poi_latitude": "36.1232992",
      "poi_longitude": "-95.9400579",
      "poi_miles_from_property": "8.3",
      "poi_walking_minutes": "3 hours 6 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-747-2566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ8vHnFGTtocRP92Gc3-3SIg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barber_shop"
    },
    {
      "id": "custom_5941725b-4968-4182-84ac-88e02d8b4e5d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "10GYM",
      "poi_type": "Health and Wellness",
      "poi_address": "1800 S Aspen Ave, Broken Arrow, OK 74012, USA",
      "poi_short_description": "Chain fitness center featuring an indoor pool, walking track, and sauna, plus group classes.",
      "poi_long_description": "People say this gym offers a wide variety of machines, a pool, a sauna, and a steam room. They highlight the affordable membership price and the motivating, friendly, and clean environment. They also like the personable and caring staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-e011-71da-82f9-6d1e1e62e8e1.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e011-71da-82f9-6d1e1e62e8e1",
        "storage_key": "property/6767906449165588/019d2708-e011-71da-82f9-6d1e1e62e8e1.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://10gym.com/broken-arrow-ok/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11720724796821001426&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "10gym",
      "poi_latitude": "36.0335826",
      "poi_longitude": "-95.8157827",
      "poi_miles_from_property": "4.6",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-251-4855",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOe0w-qqOtocR0tSgiBphqKI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_d28bda85-7c8b-420a-90a1-799b2de11b26",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Saint Francis Hospital",
      "poi_type": "Health and Wellness",
      "poi_address": "6161 S Yale Ave, Tulsa, OK 74136, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-e213-70c9-abc5-57c99b5340bd.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e213-70c9-abc5-57c99b5340bd",
        "storage_key": "property/6767906449165588/019d2708-e213-70c9-abc5-57c99b5340bd.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.saintfrancis.com/location/saint-francis-hospital",
      "poi_directions_map_url": "https://maps.google.com/?cid=60921030837772717&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "saint-francis-hospital",
      "poi_latitude": "36.0717124",
      "poi_longitude": "-95.919824",
      "poi_miles_from_property": "4",
      "poi_walking_minutes": "1 hour 32 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-494-2200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa6a-71eb-b58f-94a19bd39a8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa6a-71eb-b58f-94a19bd39a8a",
        "storage_key": "property/6767906449165588/019d2708-fa6a-71eb-b58f-94a19bd39a8a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJZbj84V-StocRraFv0lpv2AA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_c4b71794-fa8b-482f-b87a-7319a310e528",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Hillcrest South",
      "poi_type": "Health and Wellness",
      "poi_address": "8801 S 101st E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-e462-7682-9e7b-b797a53e7bb5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e462-7682-9e7b-b797a53e7bb5",
        "storage_key": "property/6767906449165588/019d2708-e462-7682-9e7b-b797a53e7bb5.webp",
        "width": 1280,
        "height": 890
      },
      "poi_business_url": "https://hillcrest.com/find-a-provider/location/hillcrestsouth8801s101steave/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4505690926352009573&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hillcrest-south",
      "poi_latitude": "36.0354556",
      "poi_longitude": "-95.8635828",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "42 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-294-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa6a-71eb-b58f-94a19bd39a8a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa6a-71eb-b58f-94a19bd39a8a",
        "storage_key": "property/6767906449165588/019d2708-fa6a-71eb-b58f-94a19bd39a8a.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJx-fcY9aNtocRZYnpfAZuhz4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "hospital"
    },
    {
      "id": "custom_a33f2096-9f69-434b-b07e-53a980df50b0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Rhema Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "People say this park offers a beautiful display of Christmas lights, with a light show synchronized to music. They highlight the festive and family-friendly atmosphere, and the opportunity to walk or drive through the light experience. They also like the availability of hot cocoa, popcorn, and horse-drawn carriage rides.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-e42c-77d3-ae7a-070ee573e71d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e42c-77d3-ae7a-070ee573e71d",
        "storage_key": "property/6767906449165588/019d2708-e42c-77d3-ae7a-070ee573e71d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.rhemalights.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7029601498986534882&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "rhema-park",
      "poi_latitude": "36.0599323",
      "poi_longitude": "-95.808211",
      "poi_miles_from_property": "3.7",
      "poi_walking_minutes": "1 hour 23 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-258-1588",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa71-71a9-99ed-f61a18d63538.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa71-71a9-99ed-f61a18d63538",
        "storage_key": "property/6767906449165588/019d2708-fa71-71a9-99ed-f61a18d63538.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJSQLUiIyLtocR4lelo1EpjmE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_4dddd08c-6f79-4d9a-b2d4-92c0c3491532",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "LaFortune Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5202 S Hudson Ave, Tulsa, OK 74135, USA",
      "poi_short_description": "Vast park, with playground areas, golf options, tennis courts, a pool and a community center.",
      "poi_long_description": "People say this park offers a golf course, playgrounds, walking trails, and picnic areas with grills. They highlight the park is clean, well-maintained, and safe, with plenty of parking and covered pavilions. They also like the wide walkways and the peaceful, quiet atmosphere. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-e602-70fd-b30e-5e6aead768ea.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e602-70fd-b30e-5e6aead768ea",
        "storage_key": "property/6767906449165588/019d2708-e602-70fd-b30e-5e6aead768ea.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www2.tulsacounty.org/parks/parks-facilities/lafortune-park/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16150311355247615027&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "lafortune-park",
      "poi_latitude": "36.0830954",
      "poi_longitude": "-95.9178327",
      "poi_miles_from_property": "4.3",
      "poi_walking_minutes": "1 hour 35 mins",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-496-6220",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa71-71a9-99ed-f61a18d63538.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa71-71a9-99ed-f61a18d63538",
        "storage_key": "property/6767906449165588/019d2708-fa71-71a9-99ed-f61a18d63538.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJh59BfPOStocRM9x9DZxuIeA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_8922a8d8-4bdb-421f-9486-9aaae14c6050",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Elam Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "Broken Arrow, OK 74011, USA",
      "poi_short_description": "Fenced park featuring picnic tables and a playground for children.",
      "poi_long_description": "People say this park offers a variety of playground equipment, including slides, swings, and a zipline, as well as picnic tables, soccer fields, and a water fountain with a bottle refill station. They highlight the park's clean bathrooms, shaded seating areas, and fenced-in playground, making it safe and enjoyable for children of all ages. They also like the park's accessible layout and thoughtful design, especially for toddlers.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-e7e8-748d-aea4-5cf498076cc0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e7e8-748d-aea4-5cf498076cc0",
        "storage_key": "property/6767906449165588/019d2708-e7e8-748d-aea4-5cf498076cc0.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://www.brokenarrowok.gov/Home/Components/News/News/2234/15",
      "poi_directions_map_url": "https://maps.google.com/?cid=8281012522592314667&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "elam-park",
      "poi_latitude": "36.0062955",
      "poi_longitude": "-95.8209464",
      "poi_miles_from_property": "6.6",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "38 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-251-5311",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa71-71a9-99ed-f61a18d63538.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa71-71a9-99ed-f61a18d63538",
        "storage_key": "property/6767906449165588/019d2708-fa71-71a9-99ed-f61a18d63538.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJW_XMAgCPtocRKyWtvQMR7HI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_cfaf830e-940c-4b59-b44c-b536cc0a4c67",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Hunter Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "5804 E 91st St, Tulsa, OK 74137, USA",
      "poi_short_description": "Well-maintained park featuring a playground for kids and a dog park for pets, plus a splash pad and a pond for fishing.",
      "poi_long_description": "People say this park offers a disc golf course, a dog park with separate areas for large and small dogs, and a pond with fishing piers. They highlight the peaceful and safe environment, and the extensive dog park with play features and picnic spots. They also like the wooded trails and the availability of water fountains for dogs. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-e9ee-77df-925b-51e58309c783.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-e9ee-77df-925b-51e58309c783",
        "storage_key": "property/6767906449165588/019d2708-e9ee-77df-925b-51e58309c783.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cityoftulsa.org/culture--recreation/tulsa-parks.aspx",
      "poi_directions_map_url": "https://maps.google.com/?cid=13505697753323470752&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hunter-park",
      "poi_latitude": "36.0298785",
      "poi_longitude": "-95.9117817",
      "poi_miles_from_property": "4.7",
      "poi_walking_minutes": "1 hour 43 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-596-7275",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa71-71a9-99ed-f61a18d63538.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa71-71a9-99ed-f61a18d63538",
        "storage_key": "property/6767906449165588/019d2708-fa71-71a9-99ed-f61a18d63538.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJwzzqpPeRtocRoP-i5ozgbbs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_14adf111-e633-476c-81c3-580fde1a91a3",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Haikey Creek Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "11327 S Garnett Rd, Broken Arrow, OK 74011, USA",
      "poi_short_description": "Calm park featuring frisbee golf, disc golf, swings and a playground for kids.",
      "poi_long_description": "People say this park offers a disc golf course, multiple playgrounds, walking trails, and picnic areas. They highlight the park is large, well-maintained, and has plenty of shaded areas. They also like the clean pavilions, volleyball, horseshoes, and open spaces for various activities. ",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-ea65-7715-9c0e-6762743cdc7c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ea65-7715-9c0e-6762743cdc7c",
        "storage_key": "property/6767906449165588/019d2708-ea65-7715-9c0e-6762743cdc7c.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=15453125230281067031&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "haikey-creek-park",
      "poi_latitude": "35.9918271",
      "poi_longitude": "-95.8526659",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 918-369-5998",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa71-71a9-99ed-f61a18d63538.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa71-71a9-99ed-f61a18d63538",
        "storage_key": "property/6767906449165588/019d2708-fa71-71a9-99ed-f61a18d63538.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkz_xefyOtocRF4qH1IWHdNY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_2c18e2ef-34b4-4d30-a661-e64bcaa5ba4f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Cityplex Towers",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2488 E 81st St, Tulsa, OK 74137, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-eb2c-77fe-a24b-dbddfa250760.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-eb2c-77fe-a24b-dbddfa250760",
        "storage_key": "property/6767906449165588/019d2708-eb2c-77fe-a24b-dbddfa250760.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.cityplextowers.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12250163942111608689&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "cityplex-towers",
      "poi_latitude": "36.0427518",
      "poi_longitude": "-95.9528286",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 918-493-8888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJuTNcyMaTtocRcX_cgTNTAao",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_217bf5d5-96b8-4540-bc88-eeed53173b78",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Hilti - Operations Center Corporate Office",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5400 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-ed49-7698-ba8f-cd468001ee26.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-ed49-7698-ba8f-cd468001ee26",
        "storage_key": "property/6767906449165588/019d2708-ed49-7698-ba8f-cd468001ee26.webp",
        "width": 760,
        "height": 512
      },
      "poi_business_url": "http://hilti.to/ubo2wq",
      "poi_directions_map_url": "https://maps.google.com/?cid=4109057745683559288&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "hilti---operations-center-corporate-office",
      "poi_latitude": "36.0872879",
      "poi_longitude": "-95.8430938",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 30 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-252-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJUUE4gPGMtocReDMJvT9OBjk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1d2a0010-af4c-42f0-92e0-f2b77a26ae16",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Enovation Controls",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5311 S 122nd E Ave, Tulsa, OK 74146, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f122-761a-a2da-cc9a3830bb85.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f122-761a-a2da-cc9a3830bb85",
        "storage_key": "property/6767906449165588/019d2708-f122-761a-a2da-cc9a3830bb85.webp",
        "width": 1280,
        "height": 851
      },
      "poi_business_url": "https://www.enovationcontrols.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1461315099535642429&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "enovation-controls",
      "poi_latitude": "36.0861778",
      "poi_longitude": "-95.8391635",
      "poi_miles_from_property": "4.1",
      "poi_walking_minutes": "1 hour 31 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 918-317-4100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4_tas_OMtocRPY-8NFeiRxQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_73c0f898-123c-422e-946a-3cd1c4eee179",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Mill Creek General Offices",
      "poi_type": "Major Employers & Offices",
      "poi_address": "6974 E 38th St, Tulsa, OK 74145, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://www.millcreeklumber.com/distribution_general_offices_tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=17106239654103162435&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "mill-creek-general-offices",
      "poi_latitude": "36.1071459",
      "poi_longitude": "-95.8972379",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 53 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 918-794-3600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJBYu7OliNtocRQx6FKVWSZe0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_f5771c67-662e-4905-9ae4-e66fbd01960d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Air Hygiene International, Inc. - Stack and Emissions Testing",
      "poi_type": "Major Employers & Offices",
      "poi_address": "1600 W Tacoma St, Broken Arrow, OK 74012, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-f08b-7389-b516-bae50f9ecbed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d2708-f08b-7389-b516-bae50f9ecbed",
        "storage_key": "property/6767906449165588/019d2708-f08b-7389-b516-bae50f9ecbed.webp",
        "width": 1280,
        "height": 613
      },
      "poi_business_url": "https://www.airhygiene.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17853602463665443212&g_mp=Cilnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaE5lYXJieRACGAQgAA",
      "poi_item_slug": "air-hygiene-international-inc---stack-and-emissions-testing",
      "poi_latitude": "36.0713795",
      "poi_longitude": "-95.8092029",
      "poi_miles_from_property": "4.8",
      "poi_walking_minutes": "1 hour 48 mins",
      "poi_biking_minutes": "26 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 918-307-8865",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d2708-fa37-7274-9f83-7c1afe062154",
        "storage_key": "property/6767906449165588/019d2708-fa37-7274-9f83-7c1afe062154.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-Ut31oWLtocRjFHRJ9m8xPc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_aafea6dc-9a27-43fc-83ea-78769231d25f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Jarman Elementary School",
      "poi_type": "Education",
      "poi_address": "9015 E 79th St, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "https://unionps.org/index.php?pageID=426682_3",
      "poi_directions_map_url": "https://maps.google.com/?cid=15163329848068604185&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "jarman-elementary-school",
      "poi_latitude": "36.0504608",
      "poi_longitude": "-95.8761305",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-357-4335",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91e9-724d-9845-9a312f37b89a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91e9-724d-9845-9a312f37b89a",
        "storage_key": "property/6767906449165588/019cfb39-91e9-724d-9845-9a312f37b89a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ-clnx8GNtocRGQE1dij4btI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_48a8c2c3-ae8e-45f8-b7e2-62c1f0089ad5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Union Eighth Grade Center",
      "poi_type": "Education",
      "poi_address": "6501 S Garnett Rd, Broken Arrow, OK 74012, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-b77d-7179-bdd4-dc1cde5ad304.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b77d-7179-bdd4-dc1cde5ad304",
        "storage_key": "property/6767906449165588/019d7911-b77d-7179-bdd4-dc1cde5ad304.webp",
        "width": 640,
        "height": 360
      },
      "poi_business_url": "http://unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8773159022692442711&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-eighth-grade-center",
      "poi_latitude": "36.0671931",
      "poi_longitude": "-95.8503859",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "35 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-357-4325",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91e9-724d-9845-9a312f37b89a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91e9-724d-9845-9a312f37b89a",
        "storage_key": "property/6767906449165588/019cfb39-91e9-724d-9845-9a312f37b89a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJJwUczVGMtocRV6KYIaaFwHk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_78746ade-ae3f-4582-a514-775e2e6d29b6",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Union High School",
      "poi_type": "Education",
      "poi_address": "6636 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-b86d-70d9-b0d8-0a0f395ee9e5.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b86d-70d9-b0d8-0a0f395ee9e5",
        "storage_key": "property/6767906449165588/019d7911-b86d-70d9-b0d8-0a0f395ee9e5.webp",
        "width": 1000,
        "height": 700
      },
      "poi_business_url": "https://www.unionps.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2856521135297069003&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "union-high-school",
      "poi_latitude": "36.0666635",
      "poi_longitude": "-95.8701703",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-357-4323",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91e9-724d-9845-9a312f37b89a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91e9-724d-9845-9a312f37b89a",
        "storage_key": "property/6767906449165588/019cfb39-91e9-724d-9845-9a312f37b89a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB7WuyaSNtocRy__GitZmpCc",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_87de132f-1a12-4a6b-aa4d-9b250d5e36b1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "The University of Tulsa",
      "poi_type": "Education",
      "poi_address": "800 S Tucker Dr, Tulsa, OK 74104, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-b896-7300-bc66-965f653287ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b896-7300-bc66-965f653287ed",
        "storage_key": "property/6767906449165588/019d7911-b896-7300-bc66-965f653287ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://www.utulsa.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=12534755682749092613&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-university-of-tulsa",
      "poi_latitude": "36.1520526",
      "poi_longitude": "-95.9460753",
      "poi_miles_from_property": "10.7 mi",
      "poi_walking_minutes": "3 hours 57 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 918-631-2000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91e9-724d-9845-9a312f37b89a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91e9-724d-9845-9a312f37b89a",
        "storage_key": "property/6767906449165588/019cfb39-91e9-724d-9845-9a312f37b89a.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJM0KAdPzstocRBZORqOFl9K0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_cfb1c630-82cb-407b-b068-4f3561c9436a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Black Bear Diner Tulsa",
      "poi_type": "Restaurants",
      "poi_address": "9026 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Easygoing chain serving familiar all-day comfort food & desserts in a woodsy setting.",
      "poi_long_description": "People say this restaurant serves delicious pancakes, burgers, and bacon. They also highlight the generous portions, affordable prices, and family-friendly atmosphere.\n\nOther reviews mention the food can be bland.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-b7b2-7545-b9b0-fd00ba8689f9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-b7b2-7545-b9b0-fd00ba8689f9",
        "storage_key": "property/6767906449165588/019d7911-b7b2-7545-b9b0-fd00ba8689f9.webp",
        "width": 888,
        "height": 500
      },
      "poi_business_url": "https://blackbeardiner.com/location/tulsa/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8977697759841423897&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "black-bear-diner-tulsa",
      "poi_latitude": "36.0604657",
      "poi_longitude": "-95.8764064",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-459-8711",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91ed-701b-a0e6-6c0d9c18148e",
        "storage_key": "property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ3Qxwi-qNtocRGRIr9Iswl3w",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "american_restaurant"
    },
    {
      "id": "custom_a9598a62-85a0-49cf-8c83-f17f821caa70",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Uncle Julio's Mexican Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "10333 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Tex-Mex chain serving mesquite-grilled fare & margarita-sangria swirls in a hacienda-style space.",
      "poi_long_description": "People say this Mexican restaurant serves delicious fajitas, homemade tortillas, and margaritas. They also highlight the attentive service and fun, festive atmosphere.\n\nOther reviews mention the portions can be small.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-c564-712d-896b-dbd51af882bb.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c564-712d-896b-dbd51af882bb",
        "storage_key": "property/6767906449165588/019d7911-c564-712d-896b-dbd51af882bb.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://unclejulios.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8326019147073341189&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "uncle-julio-s-mexican-restaurant",
      "poi_latitude": "36.0622881",
      "poi_longitude": "-95.8608222",
      "poi_miles_from_property": "0.6 mi",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 918-999-0054",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91ed-701b-a0e6-6c0d9c18148e",
        "storage_key": "property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7TjRyvSNtocRBUdoFk32i3M",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "mexican_restaurant"
    },
    {
      "id": "custom_91a9b6b7-0507-4725-926a-6c1e0822aa0f",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Whataburger",
      "poi_type": "Restaurants",
      "poi_address": "10028 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Circa-1950 fast-food chain for counter-serve burgers, some stacked with multiple patties.",
      "poi_long_description": "People say this fast food restaurant serves delicious burgers and chicken sandwiches, and the staff can be friendly.\n\nOther reviews mention the service can be slow and orders can be incorrect.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-c026-70df-9dc9-c6dce08897ed.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c026-70df-9dc9-c6dce08897ed",
        "storage_key": "property/6767906449165588/019d7911-c026-70df-9dc9-c6dce08897ed.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://locations.whataburger.com/ok/tulsa/10028-e-71st-st.html/?utm_source=yextpages&utm_medium=locallistings&utm_campaign=yextpages",
      "poi_directions_map_url": "https://maps.google.com/?cid=2167497199268858015&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "whataburger",
      "poi_latitude": "36.0603088",
      "poi_longitude": "-95.8645826",
      "poi_miles_from_property": "0.3 mi",
      "poi_walking_minutes": "7 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-615-4666",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91ed-701b-a0e6-6c0d9c18148e",
        "storage_key": "property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJoTILAGuNtocRnwgTBjh_FB4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fast_food_restaurant"
    },
    {
      "id": "custom_774ac595-32ba-4c71-83f6-0452f72f8ea4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Olive Garden Italian Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "7019 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Lively, family-friendly chain featuring Italian standards such as pastas & salads.",
      "poi_long_description": "People say this Italian restaurant serves delicious soups, salads, breadsticks, and entrees. They also highlight the generous portions, great prices, and friendly, efficient service.\n\nOther reviews mention the food can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-c432-7071-91d7-5c82efb639c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c432-7071-91d7-5c82efb639c6",
        "storage_key": "property/6767906449165588/019d7911-c432-7071-91d7-5c82efb639c6.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.olivegarden.com/locations/ok/tulsa/tulsa-memorial/1054?cmpid=br:og_ag:ie_ch:loc_ca:OGGMB_sn:gmb_gt:tulsa-ok-1054_pl:locurl_rd:1028",
      "poi_directions_map_url": "https://maps.google.com/?cid=1956020961746126449&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "olive-garden-italian-restaurant",
      "poi_latitude": "36.062018",
      "poi_longitude": "-95.885692",
      "poi_miles_from_property": "1.4 mi",
      "poi_walking_minutes": "31 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-254-0082",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91ed-701b-a0e6-6c0d9c18148e",
        "storage_key": "property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8ar2VJCNtocRcYYYhrMuJRs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_700ce69d-2bb9-4047-befb-c9db52005d99",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Chuy's",
      "poi_type": "Restaurants",
      "poi_address": "10808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain serving \"big as yo' face\" burritos & other Tex-Mex dishes in kitschy, eclectic settings.",
      "poi_long_description": "People say this Tex-Mex restaurant serves delicious fajitas, chile rellenos, and shrimp tacos. They also highlight the reasonable prices, fun and relaxed vibe, and friendly service.\n\nOther reviews mention the food can be overcooked.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-c544-7040-a1db-28a5791a7f59.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-c544-7040-a1db-28a5791a7f59",
        "storage_key": "property/6767906449165588/019d7911-c544-7040-a1db-28a5791a7f59.webp",
        "width": 640,
        "height": 480
      },
      "poi_business_url": "https://www.chuys.com/locations/ok/tulsa/tulsa-ok/6031?cmpid=br:chy_ag:ie_ch:loc_ca:CHYGMB_sn:gmb_gt:tulsa-ok-6031_pl:locurl_rd:1030",
      "poi_directions_map_url": "https://maps.google.com/?cid=15724210836110639618&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "chuy-s",
      "poi_latitude": "36.0603153",
      "poi_longitude": "-95.8561867",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "19 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-252-0405",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91ed-701b-a0e6-6c0d9c18148e",
        "storage_key": "property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ8TEdVbONtocRAgK563GeN9o",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "tex_mex_restaurant"
    },
    {
      "id": "custom_9cd07612-4c02-4bf8-899b-3d8439a0d4c5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Kirin Asian and Sushi Cuisine Tulsa",
      "poi_type": "Restaurants",
      "poi_address": "8041 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual, strip-mall choice for Asian cuisine, sushi, noodles & wok classics, plus lunch specials.",
      "poi_long_description": "People say this Asian restaurant serves delicious sushi, fried union rolls, and spicy chili wontons. They also highlight the friendly and attentive staff, and the calm and welcoming atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-cc31-71b7-a706-5b19a61ee4a2.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-cc31-71b7-a706-5b19a61ee4a2",
        "storage_key": "property/6767906449165588/019d7911-cc31-71b7-a706-5b19a61ee4a2.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://kirin-tulsa.com/?utm_source=google",
      "poi_directions_map_url": "https://maps.google.com/?cid=12386508352282618263&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "kirin-asian-and-sushi-cuisine-tulsa",
      "poi_latitude": "36.0472066",
      "poi_longitude": "-95.8679719",
      "poi_miles_from_property": "0.8 mi",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-893-8006",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91ed-701b-a0e6-6c0d9c18148e",
        "storage_key": "property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJrdhVlEKOtocRl-k2Sbi35as",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_restaurant"
    },
    {
      "id": "custom_138d29e7-833e-44ad-aa64-d31f45f849df",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Blue Coast Juicy Seafood",
      "poi_type": "Restaurants",
      "poi_address": "8215 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Casual venue serving fried baskets, boiled bags of seafood, and grilled fish such as shrimp and crab to eat in or take away, plus beer, wine, and hard liquor.",
      "poi_long_description": "People say this restaurant serves delicious seafood boils, especially the E Combo Special with lobster tail, shrimp, and snow crab. They also highlight the generous portions, flavorful seasoning, and reasonable prices for the boil combos.\n\nOther reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-cfb0-75ca-91b9-cb54fba54aba.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-cfb0-75ca-91b9-cb54fba54aba",
        "storage_key": "property/6767906449165588/019d7911-cfb0-75ca-91b9-cb54fba54aba.webp",
        "width": 1280,
        "height": 961
      },
      "poi_business_url": "http://bluecoastjuicytulsa.com/?utm_source=gmb&utm_medium=website",
      "poi_directions_map_url": "https://maps.google.com/?cid=2767304385105026187&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "blue-coast-juicy-seafood",
      "poi_latitude": "36.0613365",
      "poi_longitude": "-95.8850021",
      "poi_miles_from_property": "1.3 mi",
      "poi_walking_minutes": "30 mins",
      "poi_biking_minutes": "8 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-258-0188",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91ed-701b-a0e6-6c0d9c18148e",
        "storage_key": "property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5aprcuiNtocRi9yQK61wZyY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_93778c13-b453-4bc5-9f68-d5d582978e3a",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "The Home Depot",
      "poi_type": "Shopping & Retail",
      "poi_address": "9808 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain home improvement retailer for tools, appliances & other products (some offer truck rentals).",
      "poi_long_description": "People say this home improvement store has helpful and friendly staff who are knowledgeable about their areas. They also highlight the well-stocked store and efficient delivery service.\n\nSome reviews mention the customer service can be inconsistent.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-d8aa-7578-bc0b-d2b16035bb8a.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-d8aa-7578-bc0b-d2b16035bb8a",
        "storage_key": "property/6767906449165588/019d7911-d8aa-7578-bc0b-d2b16035bb8a.webp",
        "width": 704,
        "height": 292
      },
      "poi_business_url": "https://www.homedepot.com/l/South-Tulsa/OK/Tulsa/74133/3903?emt=MSGoogleMaps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1237148003252488434&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "the-home-depot",
      "poi_latitude": "36.0595045",
      "poi_longitude": "-95.8665226",
      "poi_miles_from_property": "0.4 mi",
      "poi_walking_minutes": "9 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 918-459-3700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91e9-724d-9845-9dababf1258a",
        "storage_key": "property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJvaH1r7CNtocR8shy5I07KxE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_improvement_store"
    },
    {
      "id": "custom_b8967f9b-2280-4bee-96aa-9313c2d3b1ca",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Sam's Club",
      "poi_type": "Shopping & Retail",
      "poi_address": "6922 S Mingo Rd, Tulsa, OK 74133, USA",
      "poi_short_description": "Membership-only warehouse chain selling a variety of bulk grocery items, electronics & home goods.",
      "poi_long_description": "People say this warehouse club offers a wide selection of products and good prices. They also highlight the friendly staff and convenient bulk shopping.\n\nSome reviews mention the store can be crowded.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-e287-75eb-a8e3-9b6630e0f61f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e287-75eb-a8e3-9b6630e0f61f",
        "storage_key": "property/6767906449165588/019d7911-e287-75eb-a8e3-9b6630e0f61f.webp",
        "width": 1280,
        "height": 591
      },
      "poi_business_url": "https://www.samsclub.com/club/6342-tulsa-ok",
      "poi_directions_map_url": "https://maps.google.com/?cid=2142616615335699436&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "sam-s-club",
      "poi_latitude": "36.0628489",
      "poi_longitude": "-95.8716547",
      "poi_miles_from_property": "0.7 mi",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-252-9503",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91e9-724d-9845-9dababf1258a",
        "storage_key": "property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJOxq7n7uNtocR7CPvpnUavB0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_e7f9f2c4-b631-470d-bfc4-d11dc0f9aaae",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Academy Sports + Outdoors",
      "poi_type": "Shopping & Retail",
      "poi_address": "7850 S 107th E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "Sporting goods chain selling athletic apparel & footwear, plus outdoor gear & fitness equipment.",
      "poi_long_description": "Shoppers say this sporting goods store offers a wide selection of shoes, camping equipment, and fishing gear, with great deals and fair prices. They also highlight the friendly and helpful staff, and the clean and well-organized store.\n\nSome reviews mention the online shopping experience can be disappointing.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-e6ce-7785-8524-a0756f533258.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e6ce-7785-8524-a0756f533258",
        "storage_key": "property/6767906449165588/019d7911-e6ce-7785-8524-a0756f533258.webp",
        "width": 1137,
        "height": 640
      },
      "poi_business_url": "https://www.academy.com/storelocator/oklahoma/tulsa/store-0084",
      "poi_directions_map_url": "https://maps.google.com/?cid=13160923161417580787&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "academy-sports-outdoors",
      "poi_latitude": "36.0493635",
      "poi_longitude": "-95.8561662",
      "poi_miles_from_property": "1.8 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-249-5700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91e9-724d-9845-9dababf1258a",
        "storage_key": "property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ47lbY8uNtocR84CBwOL9pLY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sporting_goods_store"
    },
    {
      "id": "custom_38eaf93f-af7a-4459-8697-cb91b55cf068",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Barnes & Noble",
      "poi_type": "Shopping & Retail",
      "poi_address": "Woodland Plaza, 8620 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Bookseller chain stocking housebrand eReader, plus a broad selection of titles for adults & kids.",
      "poi_long_description": "People say this bookstore offers a wide selection of books, including manga, and a variety of novelty items, educational toys, puzzles, and crafts. They highlight the spacious layout, the reading area, and the cafe. They also like the helpful and friendly staff.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-e7c4-71b9-a983-8357ed85bd2f.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-e7c4-71b9-a983-8357ed85bd2f",
        "storage_key": "property/6767906449165588/019d7911-e7c4-71b9-a983-8357ed85bd2f.webp",
        "width": 1280,
        "height": 724
      },
      "poi_business_url": "https://stores.barnesandnoble.com/store/2585",
      "poi_directions_map_url": "https://maps.google.com/?cid=15890114772298800904&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "barnes-noble",
      "poi_latitude": "36.0601131",
      "poi_longitude": "-95.8799161",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-250-5034",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91e9-724d-9845-9dababf1258a",
        "storage_key": "property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcYxgZ5aNtocRCJ8OKzIHhdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "book_store"
    },
    {
      "id": "custom_e25a0881-e0b7-48db-a75a-167dddf7058d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Five Below",
      "poi_type": "Shopping & Retail",
      "poi_address": "8802 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Teen-oriented retail chain for a large assortment of games, snacks, jewelry, room decor & more.",
      "poi_long_description": "Teen-oriented retail chain for a large assortment of games, snacks, jewelry, room decor & more.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-f1bd-738b-9842-a7463a5b7c12.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f1bd-738b-9842-a7463a5b7c12",
        "storage_key": "property/6767906449165588/019d7911-f1bd-738b-9842-a7463a5b7c12.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "https://locations.fivebelow.com/ok/tulsa/8802-e-71st-st?utm_source=gmb&utm_medium=yext&y_source=1_MTM1Mzk0NzUtNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=10547448967947723423&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "five-below",
      "poi_latitude": "36.0598107",
      "poi_longitude": "-95.8781866",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "23 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-238-0033",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91e9-724d-9845-9dababf1258a",
        "storage_key": "property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJM20uC-uNtocRn6IVHfQQYJI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_ca0bc673-8e1f-4415-84a8-89d8c77775d1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Vintage Stock",
      "poi_type": "Shopping & Retail",
      "poi_address": "6808 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Home-entertainment chain that buys & sells movies, music & games, books, comics, toys & memorabilia.",
      "poi_long_description": "People say this DVD store offers a great selection of movies and games at affordable prices, and they praise the friendly and helpful staff. They also highlight the store's long-standing sales and well-stocked, clean, and organized environment.\n\nSome reviews mention the prices for selling items to the store can be low.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-f497-72e6-b6d5-214829840841.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f497-72e6-b6d5-214829840841",
        "storage_key": "property/6767906449165588/019d7911-f497-72e6-b6d5-214829840841.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://vintagestock.com/index.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=13877543383808209985&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "vintage-stock",
      "poi_latitude": "36.0638643",
      "poi_longitude": "-95.8873607",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "38 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-254-8281",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91fa-7018-8d1e-cb94deb2674a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91fa-7018-8d1e-cb94deb2674a",
        "storage_key": "property/6767906449165588/019cfb39-91fa-7018-8d1e-cb94deb2674a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYVLR84-NtocRQfT1Yi7wlsA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "store"
    },
    {
      "id": "custom_783706da-6485-49e5-aeeb-b68da89425f0",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Ollie's Bargain Outlet",
      "poi_type": "Shopping & Retail",
      "poi_address": "6910 S Memorial Dr, Tulsa, OK 74133, USA",
      "poi_short_description": "Discount chain carrying a wide range of closeout merchandise, including food, housewares & toys.",
      "poi_long_description": "People say this discount store offers a wide variety of items, including books, rugs, and home goods. They also highlight the great deals and low prices, and the friendly staff.\n\nSome reviews mention the store can be messy.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-f3d9-70aa-a1f4-8437d9058f28.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-f3d9-70aa-a1f4-8437d9058f28",
        "storage_key": "property/6767906449165588/019d7911-f3d9-70aa-a1f4-8437d9058f28.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://ollies.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13397258960413962710&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "ollie-s-bargain-outlet",
      "poi_latitude": "36.0631985",
      "poi_longitude": "-95.887142",
      "poi_miles_from_property": "1.6 mi",
      "poi_walking_minutes": "36 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "+1 918-957-5388",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91e9-724d-9845-9dababf1258a",
        "storage_key": "property/6767906449165588/019cfb39-91e9-724d-9845-9dababf1258a.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJx83C0fqNtocR1rFk8wqg7Lk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "discount_store"
    },
    {
      "id": "custom_79b65067-fb5b-4ecb-8727-ab9dfcb1ff83",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Cinemark Tulsa and IMAX",
      "poi_type": "Entertainment",
      "poi_address": "10802 E 71st St, Tulsa, OK 74133, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "People say this movie theater offers a wide selection of movies, including IMAX and 3D options, and has comfortable reclining seats. They highlight the delicious popcorn, the good sound and picture quality, and the clean theaters and bathrooms. They also like the friendly and helpful staff, and the efficient service.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-fa2f-7378-b705-bf8a06ccaac0.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fa2f-7378-b705-bf8a06ccaac0",
        "storage_key": "property/6767906449165588/019d7911-fa2f-7378-b705-bf8a06ccaac0.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.cinemark.com/theatres/ok-tulsa/cinemark-tulsa-and-imax?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxOTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=9116249517963305424&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinemark-tulsa-and-imax",
      "poi_latitude": "36.05829689999999",
      "poi_longitude": "-95.8564432",
      "poi_miles_from_property": "1.0 mi",
      "poi_walking_minutes": "22 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 918-250-1956",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7912-1703-7627-a702-432823d2bf09.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d7912-1703-7627-a702-432823d2bf09",
        "storage_key": "property/6767906449165588/019d7912-1703-7627-a702-432823d2bf09.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJ12hyVbONtocR0GEH-qJsg34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_b7381d28-be80-40e2-b9aa-021b125b69b4",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Cinergy's Extreme Escape Room - Tulsa",
      "poi_type": "Entertainment",
      "poi_address": "6808 S Memorial Dr Suite #300, Tulsa, OK 74133, USA",
      "poi_short_description": "Escape room center with ax throwing, bowling, and a bar, plus a movie theater.",
      "poi_long_description": "People say this escape room center offers a variety of escape rooms and an arcade. They also highlight the fun atmosphere and the opportunity to win prizes.\n\nSome reviews mention the escape rooms can be poorly maintained.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7911-fc5c-715e-8997-f16552eae224.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7911-fc5c-715e-8997-f16552eae224",
        "storage_key": "property/6767906449165588/019d7911-fc5c-715e-8997-f16552eae224.webp",
        "width": 1200,
        "height": 786
      },
      "poi_business_url": "https://www.cinergy.com/escape-room/tulsa?utm_source=google&utm_medium=organic&utm_campaign=gmb-listing-escape",
      "poi_directions_map_url": "https://maps.google.com/?cid=5180287137507824221&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "cinergy-s-extreme-escape-room-tulsa",
      "poi_latitude": "36.0640143",
      "poi_longitude": "-95.8890616",
      "poi_miles_from_property": "1.7 mi",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 918-894-6888",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91fa-7018-8d1e-cb94deb2674a.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91fa-7018-8d1e-cb94deb2674a",
        "storage_key": "property/6767906449165588/019cfb39-91fa-7018-8d1e-cb94deb2674a.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJYRH29AyNtocRXdKtibQT5Ec",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_38e32870-7549-45ad-84ad-41565ddecf2d",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Hunter Park Pond",
      "poi_type": "Entertainment",
      "poi_address": "Creek Tumpike Trl, Tulsa, OK 74137, USA",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "https://maps.google.com/?cid=2691387023598245280&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "hunter-park-pond",
      "poi_latitude": "36.0293125",
      "poi_longitude": "-95.9110908",
      "poi_miles_from_property": "4.6 mi",
      "poi_walking_minutes": "1 hour 41 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "false",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91f9-7193-af3a-062429328f37.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91f9-7193-af3a-062429328f37",
        "storage_key": "property/6767906449165588/019cfb39-91f9-7193-af3a-062429328f37.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQAAufeRtocRoFWrBj26WSU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_b4c2ee93-3b67-4877-a78b-d6d776bfd0ff",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Dave & Buster's Tulsa",
      "poi_type": "Entertainment",
      "poi_address": "6812 S 105th E Ave, Tulsa, OK 74133, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "People say this restaurant and entertainment venue offers delicious food, tasty drinks, and a wide variety of arcade games. They also highlight the friendly and helpful staff, and the fun and exciting atmosphere.\n\nSome reviews mention the service can be slow.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019d7912-045a-745d-a831-5a802520e040.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d7912-045a-745d-a831-5a802520e040",
        "storage_key": "property/6767906449165588/019d7912-045a-745d-a831-5a802520e040.webp",
        "width": 1280,
        "height": 864
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/tulsa",
      "poi_directions_map_url": "https://maps.google.com/?cid=12357992769235283287&g_mp=Cidnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLlNlYXJjaFRleHQQAhgEIAA",
      "poi_item_slug": "dave-buster-s-tulsa",
      "poi_latitude": "36.0651384",
      "poi_longitude": "-95.8605908",
      "poi_miles_from_property": "0.9 mi",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 918-449-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019cfb39-91ed-701b-a0e6-6c0d9c18148e",
        "storage_key": "property/6767906449165588/019cfb39-91ed-701b-a0e6-6c0d9c18148e.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJV_GbT6yNtocRV20du_JogKs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6e5b95e1-23c1-467e-9957-c42bc58d0be1",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Union 6/7 Center",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "union-6-7-center",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a014056c-ffea-430f-9a64-99989c0a9de7",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Regent Preparatory (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "regent-preparatory-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_06c32c7b-2996-4aec-9f41-c54af8d1edf5",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "Holland Hall (grades pre-K through 12)",
      "poi_type": "Education",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "holland-hall-grades-pre-k-through-12",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_b668d284-f2b4-4e2d-837f-b3d0089eacbd",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "poi_name": "JOANN Fabric and Crafts",
      "poi_type": "Shopping & Retail",
      "poi_address": "false",
      "poi_short_description": "false",
      "poi_long_description": "false",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "false",
      "poi_directions_map_url": "false",
      "poi_item_slug": "joann-fabric-and-crafts",
      "poi_latitude": "false",
      "poi_longitude": "false",
      "poi_miles_from_property": "false",
      "poi_walking_minutes": "false",
      "poi_biking_minutes": "false",
      "poi_driving_minutes": "false",
      "poi_business_phone": "false",
      "poi_map_icon": null,
      "poi_map_icon_media": null,
      "poi_google_place_id": "false",
      "poi_day_night_filter": "false",
      "poi_place_primary_type": "false"
    }
  ],
  "office_hours": [
    {
      "id": "ec_74f785434166fa83b325037b",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "day": "MON",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_65842d3b70c225e0e25a774a",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "day": "TUE",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_3830617fe42e98017cb34996",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "day": "WED",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_522c09fd473837f8123ff569",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "day": "THU",
      "open_time": "08:30",
      "close_time": "17:30"
    },
    {
      "id": "ec_64589448133ef7a6c882e4fd",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "day": "FRI",
      "open_time": "08:30",
      "close_time": "17:00"
    },
    {
      "id": "ec_d15305f751a37733cf0f5bfa",
      "source": "yardi",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "15:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_f9912f66-6ff4-4028-a2a5-b0d1222587ce",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "rating": "5.0",
      "name": "Tommy Montgomery",
      "text": "The Cedar Glade employees are very spectacular, and they gladly tolerate my repetitive inquiries about mailed packages left in the office. They are naturally patient, but professional and smiley, too. I needed the maintenance guy to fix my kitchen light, and the lady in the office already knew my apartment number.  That's pretty cool, but it also might classify me as a high maintenance tenant!  haha :)",
      "date": "2025-09-19",
      "title": ""
    },
    {
      "id": "custom_4d118b08-01bf-403b-aa49-453d881f25a0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "rating": "5.0",
      "name": "Windy Clark",
      "text": "Cedar glade is the best apts I've ever lived in. They help me in every way. The manager Sheri is amazing and she looks out for us. A manager on our side. The maintenance men James and Chris...fix everything the same day you report it. The other office staff are like family also they help you they take care of me in every way. I had a neighbor once who gave us roaches in our building. And the manager sprayed every week for 5 months and even hired in a new team to fight them in my whole building.  I been roach free for along time now. I'm so grateful for cedar glades team...I have lived here for 7 years and I love it!",
      "date": "2025-01-10",
      "title": ""
    },
    {
      "id": "custom_338f934b-801f-42cc-aa6c-7afc98f4e45b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "rating": "5.0",
      "name": "Kimberly Albright- Arellanes",
      "text": "I lived there for a little over a year and it was great. Never had a problem with neighbors, ground were clean, landscaped was always beautiful! The office staff rocks they truly take concerns seriously and work to resolve the issue.",
      "date": "2025-03-19",
      "title": ""
    },
    {
      "id": "custom_265b938e-e5a4-42a5-a377-eab9671eb267",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "rating": "5.0",
      "name": "Claudia Stanley",
      "text": "Everyone has so nice and very helpful. If we need anything done they get it done right away. The only problem I have is most of the tenants not picking up after their pets. It's hard to sit on your balcony when you see the dogs mess everywhere. And also  some people are are throwing their trash or garbage on the ground from their vehicles instead of taking it to the dumpster.  It makes the apartments look like they are not being taken care of. Thank you to the staff for being amazing!",
      "date": "2025-05-28",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_a56a4725-6508-4a68-9daf-2426300d8e3c",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "custom",
      "url_health_error": "false",
      "virtual_tour_description": "false",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb3a-2d1a-74b8-8a01-2bba733f2632.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "360 virtual tour of the outdoor swimming pool and lounge area at the apartment complex.",
        "public_id": "019cfb3a-2d1a-74b8-8a01-2bba733f2632",
        "storage_key": "property/6767906449165588/019cfb3a-2d1a-74b8-8a01-2bba733f2632.webp",
        "width": 400,
        "height": 200
      },
      "virtual_tour_title": "Cedar Glade Virtual Tour",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://tour.tourbuilder.com/?tour=6304d33ad279307c9f878b1a&sourceId=1001"
    }
  ],
  "faqs": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019cf79e-1be9-734a-85ad-38c3d557c1b9",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "cedar-glade-apts",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588"
    },
    {
      "lead_collector_id": "019cf79e-1c5f-700c-8b21-0fc902d5f886",
      "lead_source": "LANDING_PAGE",
      "name": "cedar-glade-apts",
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "apartments-with-pool-south-tulsa-ok",
      "search_query": "apartments with pool South Tulsa OK",
      "category": "Amenity",
      "h1_title": "Apartments with Pool in South Tulsa, OK",
      "h2_subtitle": "Discover Cedar Glade Apts, your ideal home with a pool. Enjoy the comfort and amenities in the charming neighborhood of South Tulsa.",
      "page_copy": "Looking for apartments with a pool in South Tulsa, OK? Cedar Glade Apts offers a delightful oasis with a refreshing pool that's perfect for relaxation and socializing. Nestled in the vibrant South Tulsa area, Cedar Glade Apts combines comfort and convenience with its one, two, and three-bedroom floor plans.\n\nAt Cedar Glade, residents enjoy luxurious amenities designed to enhance their lifestyle. Beyond the relaxing pool, take advantage of our state-of-the-art fitness center and a cozy patio to unwind. Cedar Glade Apts is not just a home; it's a community where comfort meets convenience, located right in the heart of South Tulsa, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade Apts with Pool, South Tulsa OK",
      "seo_description": "Discover Cedar Glade Apts in South Tulsa, OK. Enjoy a refreshing pool and more in our range of floor plans.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "air-conditioned-apartments-tulsa-ok",
      "search_query": "air conditioned apartments Tulsa OK",
      "category": "Amenity",
      "h1_title": "Air Conditioned Apartments in Tulsa, OK",
      "h2_subtitle": "Stay cool at Cedar Glade Apts in Tulsa, OK. Enjoy modern air-conditioned living in a vibrant community.",
      "page_copy": "Cedar Glade Apts in Tulsa, OK offers air conditioned apartments designed to provide ultimate comfort. With one, two, and three-bedroom floor plans, you are sure to find the perfect home that meets your needs. Our air conditioning system ensures you stay comfortable no matter the season.\n\nLocated in the lively area of South Tulsa, Cedar Glade Apts is more than just an apartment; it's a community where residents enjoy modern amenities. Beyond air-conditioned comfort, benefit from our high-speed internet access, dishwasher, and a lively clubhouse. Experience a cozy and convenient lifestyle here in Tulsa, OK.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Air Conditioned Living at Cedar Glade Apts",
      "seo_description": "Stay cool in air conditioned apartments at Cedar Glade Apts, Tulsa, OK. Experience comfort and convenience with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "dog-park-apartments-74133",
      "search_query": "dog park apartments 74133",
      "category": "Amenity",
      "h1_title": "Dog Park Apartments in 74133",
      "h2_subtitle": "Explore Cedar Glade Apts, where pets are welcome. Enjoy a convenient dog park in the heart of the 74133 area.",
      "page_copy": "Searching for dog park apartments in the 74133 ZIP code? Discover Cedar Glade Apts, a welcoming community that understands the needs of pet owners. Located in South Tulsa, our apartment complex features a cozy dog park, perfect for you and your furry friends to enjoy time outdoors.\n\nCedar Glade Apts offers more than just pet-friendly amenities. With a refreshing pool and a fully-equipped fitness center, indulge in the lifestyle you deserve. Our thoughtfully designed one, two, and three-bedroom floor plans provide a comfortable living space for all residents. Join us in our pet-loving community in Tulsa's 74133 area today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Pet-Friendly Apartments with Dog Park in 74133",
      "seo_description": "Experience Cedar Glade Apts, Tulsa's welcoming community with a dog park in the 74133 area. Perfect for pet-friendly living.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "luxury-apartments-with-dishwasher-south-tulsa",
      "search_query": "luxury apartments with dishwasher South Tulsa",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Dishwasher in South Tulsa",
      "h2_subtitle": "Discover Cedar Glade Apts, a luxury community in South Tulsa. Enjoy modern living with convenient in-unit dishwashers.",
      "page_copy": "Welcome to Cedar Glade Apts, where luxury meets convenience in South Tulsa. Our apartments feature modern amenities, including in-unit dishwashers, to simplify your lifestyle. Choose from our range of one, two, and three-bedroom floor plans that cater to all your living needs.\n\nLocated in the vibrant community of South Tulsa, Cedar Glade Apts combines elegance with functionality. Beyond our in-unit dishwashers, relax in our refreshing pool or get active in the fitness center. Experience the ultimate in luxury apartment living at Cedar Glade Apts, where your comfort and satisfaction are our top priorities.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: Luxury Living with Dishwasher",
      "seo_description": "Explore Cedar Glade Apts in South Tulsa. Enjoy luxury living with in-unit dishwashers and premium amenities. Discover your new home today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "tulsa-apartments-in-unit-laundry",
      "search_query": "Tulsa apartments with in unit laundry",
      "category": "Amenity",
      "h1_title": "Tulsa Apartments with In-Unit Laundry",
      "h2_subtitle": "Find your ideal home at Cedar Glade Apts. Enjoy the convenience of in-unit laundry in Tulsa's vibrant community.",
      "page_copy": "At Cedar Glade Apts in Tulsa, enjoy the convenience of apartments equipped with in-unit laundry facilities. Designed with your lifestyle in mind, our one, two, and three-bedroom floor plans offer modern living spaces with all the amenities you need. \n\nLocated in the heart of South Tulsa, Cedar Glade Apts combines practicality with luxury. Alongside our in-unit laundry, indulge in community features like our refreshing pool and a comfortable business center. Embrace a seamless living experience in Tulsa with the added ease of doing laundry right in your apartment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: Tulsa Apts with In-Unit Laundry",
      "seo_description": "Discover the ease of in-unit laundry at Cedar Glade Apts in Tulsa. Enjoy modern living with all conveniences in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "one-bedroom-apartments-south-tulsa",
      "search_query": "one bedroom apartments south tulsa",
      "category": "Floorplan",
      "h1_title": "One Bedroom Apartments in South Tulsa",
      "h2_subtitle": "Discover comfortable one-bedroom living at Cedar Glade Apts in South Tulsa, where modern amenities meet cozy design.",
      "page_copy": "Welcome to Cedar Glade Apts, offering exceptional one-bedroom apartments in South Tulsa. Our thoughtfully designed floor plans cater to your desire for comfort and functional living. Each apartment is equipped with contemporary amenities that make day-to-day living a breeze.\n\nLocated in the vibrant community of South Tulsa, Cedar Glade Apts provides more than just a place to live. Our community features, including a refreshing pool and a well-equipped fitness center, complement the cozy interiors of your one-bedroom apartment. Come and experience a harmonious blend of convenience and relaxation at Cedar Glade Apts today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: One Bedroom Apts in South Tulsa",
      "seo_description": "Find your cozy one-bedroom apartment at Cedar Glade Apts in South Tulsa. Enjoy modern amenities in a welcoming community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "two-bedroom-apartments-tulsa-ok",
      "search_query": "two bedroom apartments tulsa ok",
      "category": "Floorplan",
      "h1_title": "Two Bedroom Apartments in Tulsa, OK",
      "h2_subtitle": "Explore spacious two-bedroom living at Cedar Glade Apts in Tulsa, OK, offering modern amenities to suit your lifestyle.",
      "page_copy": "Discover the perfect blend of space and comfort at Cedar Glade Apts with our two-bedroom apartments in Tulsa, OK. Our spacious layouts provide the ideal setting for both relaxation and entertainment. With modern amenities, including air conditioning and high-speed internet, you're ensured a comfortable living experience.\n\nLocated in the bustling neighborhood of South Tulsa, Cedar Glade Apts offers more than just an apartment. Our community amenities, such as the invigorating pool and business center, enhance your lifestyle. Experience the convenience and charm of living in a two-bedroom apartment at Cedar Glade Apts today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: Two Bedroom Apts in Tulsa, OK",
      "seo_description": "Explore spacious two-bedroom apartments at Cedar Glade Apts in Tulsa, OK. Enjoy modern amenities in a vibrant South Tulsa community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "three-bedroom-apartments-near-74133",
      "search_query": "three bedroom apartments near 74133",
      "category": "Floorplan",
      "h1_title": "Three Bedroom Apartments Near 74133",
      "h2_subtitle": "Find spacious three-bedroom apartments at Cedar Glade Apts, conveniently located near the 74133 area in Tulsa.",
      "page_copy": "Searching for roomy three-bedroom apartments near the 74133 area? Look no further than Cedar Glade Apts, where generous floor plans and top-notch amenities cater to your lifestyle. Each apartment provides vast living spaces equipped with modern conveniences like dishwashers and patio access, making it ideal for families or roommates.\n\nSituated in South Tulsa, Cedar Glade Apts not only offers a great location near 74133 but also a vibrant community experience. Enjoy our exclusive amenities, including a fitness center and dog park, designed to enhance your living. Come experience the community and comfort that Cedar Glade Apts provides today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: Three Bedroom Apts Near 74133",
      "seo_description": "Discover roomy three-bedroom apartments at Cedar Glade Apts near 74133 in Tulsa. Enjoy modern living with top amenities in South Tulsa.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "apartments-near-oral-roberts-university-tulsa",
      "search_query": "apartments near oral roberts university tulsa",
      "category": "School",
      "h1_title": "Apartments Near Oral Roberts University",
      "h2_subtitle": "Cedar Glade Apts offers quality living just minutes from Oral Roberts University in Tulsa, ideal for students and faculty.",
      "page_copy": "Located conveniently near Oral Roberts University in Tulsa, Cedar Glade Apts provides a welcoming community perfect for students, faculty, and staff. Our selection of one, two, and three-bedroom apartments offers a mix of comfort and modern amenities, including high-speed internet and air conditioning.\n\nCedar Glade Apts is more than just a place to live—it's a community designed for your lifestyle. Enjoy the refreshing pool, stay active in the fitness center, or relax in our clubhouse. Experience the ease of living close to campus while enjoying all that South Tulsa has to offer. Discover your new home today at Cedar Glade Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: Apts Near Oral Roberts University",
      "seo_description": "Find convenient living at Cedar Glade Apts, near Oral Roberts University in Tulsa. Perfect for students and faculty.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "cedar-glade-apts-by-tcc-southeast-campus",
      "search_query": "cedar glade apts by tulsa community college southeast campus",
      "category": "School",
      "h1_title": "Cedar Glade Apts by TCC Southeast Campus",
      "h2_subtitle": "Discover Cedar Glade Apts, ideally located near Tulsa Community College Southeast Campus, offering comfort and convenience.",
      "page_copy": "Nestled near the Tulsa Community College Southeast Campus, Cedar Glade Apts provides a perfect living environment for students and faculty alike. Our spacious one, two, and three-bedroom apartments feature modern amenities such as dishwashers and patios to enrich your living experience.\n\nCedar Glade Apts is not just a home but a vibrant community. Take advantage of our business center and fitness facilities, or unwind at our pool and dog park. The proximity to TCC Southeast Campus ensures that educational pursuits are within easy reach, making it the perfect spot for those connected with the campus. Join our community today and enjoy the benefits of Cedar Glade Apts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: Apts Near TCC Southeast Campus",
      "seo_description": "Live comfortably at Cedar Glade Apts, conveniently located by Tulsa Community College Southeast Campus with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "ou-tulsa-nearby-apartments-south-tulsa",
      "search_query": "ou-tulsa nearby apartments south tulsa",
      "category": "School",
      "h1_title": "OU-Tulsa Nearby Apartments in South Tulsa",
      "h2_subtitle": "Explore Cedar Glade Apts, your ideal living solution near OU-Tulsa in South Tulsa, offering modern amenities and convenient access.",
      "page_copy": "If you're seeking comfortable living near OU-Tulsa, Cedar Glade Apts in South Tulsa offers the perfect solution. Situated just a short drive away, our one, two, and three-bedroom apartments are designed to meet the needs of students, faculty, and professionals.\n\nAt Cedar Glade Apts, you’ll discover a community focused on convenience and comfort, with amenities such as high-speed internet access, air conditioning, and a welcoming clubhouse. Enjoy easy access to both educational commitments and vibrant city life. Whether you're studying, teaching, or working near OU-Tulsa, Cedar Glade Apts provides the ideal home base in South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: Apts Near OU-Tulsa in South Tulsa",
      "seo_description": "Discover Cedar Glade Apts in South Tulsa, with easy access to OU-Tulsa and modern amenities. Perfect for students and professionals.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "apartments-near-saint-francis-hospital-tulsa",
      "search_query": "apartments near Saint Francis Hospital Tulsa",
      "category": "Hospital",
      "h1_title": "Apartments Near Saint Francis Hospital Tulsa",
      "h2_subtitle": "Cedar Glade Apts offers comfortable living close to Saint Francis Hospital in Tulsa. Ideal for healthcare professionals and families.",
      "page_copy": "Nestled conveniently near Saint Francis Hospital, Cedar Glade Apts in Tulsa is perfect for healthcare professionals and their families seeking comfortable living. Our spacious one, two, and three-bedroom floor plans come with modern amenities like high-speed Internet and dishwashers, catering to a variety of needs.\n\nAt Cedar Glade Apts, residents can unwind with numerous on-site amenities such as a refreshing pool, fitness center, and cozy clubhouse. Enjoy the best of both work and leisure, with close proximity to the hospital and the vibrant South Tulsa community. Discover a seamless blend of convenience and comfort at Cedar Glade Apts today.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: Apts Near Saint Francis Hospital",
      "seo_description": "Find your perfect home at Cedar Glade Apts, offering comfort near Saint Francis Hospital in Tulsa, ideal for healthcare staff and families.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "cedar-glade-apartments-near-hillcrest-south-hospital",
      "search_query": "Cedar Glade Apartments near Hillcrest South Hospital Oklahoma",
      "category": "Hospital",
      "h1_title": "Cedar Glade Apartments Near Hillcrest South",
      "h2_subtitle": "Find your home at Cedar Glade Apartments, conveniently located near Hillcrest South Hospital in Oklahoma, with exceptional amenities.",
      "page_copy": "Cedar Glade Apartments offers an exceptional living experience near Hillcrest South Hospital in Tulsa, Oklahoma. Our community is perfect for healthcare professionals and families, providing easy access to work and leisure with our prime location in South Tulsa.\n\nOur one, two, and three-bedroom apartments feature modern amenities like air conditioning, high-speed Internet access, and a business center. Whether unwinding at the pool, working out in the fitness center, or enjoying the nearby parks, Cedar Glade Apartments combines convenience with comfort, making it the ideal place to call home near Hillcrest South Hospital.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: Apts Near Hillcrest South Hospital",
      "seo_description": "Live near Hillcrest South Hospital at Cedar Glade Apartments in Tulsa, Oklahoma. Enjoy comfort and convenience with top-tier amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "apartments-near-rhema-park-tulsa",
      "search_query": "apartments near Rhema Park Tulsa",
      "category": "Park",
      "h1_title": "Apartments Near Rhema Park Tulsa",
      "h2_subtitle": "Discover Cedar Glade Apts, located near Rhema Park in Tulsa. Experience comfort and prime convenience in South Tulsa.",
      "page_copy": "Experience the convenience of living near Rhema Park at Cedar Glade Apartments in Tulsa. Situated in a serene setting, our community is ideal for those who love nature and proximity to outdoor activities. Our one, two, and three-bedroom floor plans ensure there's a perfect fit for everyone.\n\nCedar Glade Apartments offers a multitude of amenities, including a refreshing swimming pool, fitness center, and a pet-friendly environment with a cozy dog park. With easy access to Rhema Park and the vibrant South Tulsa neighborhood, you'll enjoy a perfect blend of relaxation and activity here at Cedar Glade.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade: Apts Near Rhema Park Tulsa",
      "seo_description": "Cedar Glade Apartments offers excellent living near Rhema Park in Tulsa. Enjoy modern amenities amidst a vibrant South Tulsa location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "cedar-glade-apts-close-to-lafortune-park",
      "search_query": "Cedar Glade Apts close to LaFortune Park",
      "category": "Park",
      "h1_title": "Cedar Glade Apts Near LaFortune Park",
      "h2_subtitle": "Discover Cedar Glade Apts, just steps away from LaFortune Park in Tulsa. Enjoy scenic views and premier community facilities.",
      "page_copy": "Cedar Glade Apts offers an idyllic living experience close to the beautiful LaFortune Park in Tulsa. Perfectly suited for those who love spending time outdoors, our location provides easy access to the park's lush green spaces and recreational amenities.\n\nOur residents enjoy spacious one, two, and three-bedroom apartments equipped with modern conveniences like dishwashers and high-speed Internet. With features including a business center, air-conditioned units, and a fitness center, Cedar Glade Apts delivers a harmonious blend of relaxation and convenience, making it the ultimate choice for comfortable living near LaFortune Park.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Cedar Glade Apts: Close to LaFortune Park",
      "seo_description": "Enjoy living near LaFortune Park at Cedar Glade Apts in Tulsa. Experience comfort and convenience with excellent amenities and a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "south-tulsa-apartments-near-elam-park",
      "search_query": "South Tulsa apartments near Elam Park",
      "category": "Park",
      "h1_title": "South Tulsa Apts Near Elam Park",
      "h2_subtitle": "Experience comfort at Cedar Glade Apts, ideally located near Elam Park in South Tulsa, offering top-notch amenities and convenience.",
      "page_copy": "Cedar Glade Apartments provides the perfect home base in South Tulsa, located conveniently near Elam Park. Residents can enjoy the ease of access to this serene park, along with all the community activities it offers, right in the heart of Tulsa.\n\nOur apartment community caters to a variety of lifestyles with its one, two, and three-bedroom options. Take advantage of the high-speed Internet access, relax by the swimming pool, or stay energized in our fitness center. Cedar Glade's proximity to Elam Park enhances the appeal of living here, combining scenic beauty with modern comforts in South Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "South Tulsa Apts: Near Elam Park",
      "seo_description": "Live near Elam Park at Cedar Glade Apts in South Tulsa. Enjoy comfort and convenience with modern amenities and a perfect location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "hunter-park-nearby-apartments-tulsa",
      "search_query": "Hunter Park nearby apartments Tulsa",
      "category": "Park",
      "h1_title": "Apts Near Hunter Park in Tulsa",
      "h2_subtitle": "Find your home at Cedar Glade Apts, conveniently located near Hunter Park in Tulsa. Enjoy comfort and excellent amenities close by.",
      "page_copy": "Discover the charm of living near Hunter Park with Cedar Glade Apartments in Tulsa. Our community is perfectly situated for enjoying the tranquility and recreation options available at this nearby park, making it ideal for nature lovers and active residents alike.\n\nCedar Glade offers a variety of spacious floor plans, from one to three bedrooms, each designed with modern amenities such as dishwashers and air conditioning. Residents also enjoy access to a swimming pool, fitness center, and a cozy dog park. The proximity to Hunter Park enhances the living experience, offering a unique blend of outdoor enjoyment and comfortable apartment living in Tulsa.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Hunter Park Nearby Apts: Cedar Glade",
      "seo_description": "Cedar Glade Apts in Tulsa offers ideal living near Hunter Park. Enjoy modern amenities and the convenience of a perfect location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5767906449162419",
      "property_id": "6767906449165588",
      "source": "generator",
      "page_item_url": "haikey-creek-park-close-by-apartments-74133",
      "search_query": "Haikey Creek Park close by Apartments in 74133",
      "category": "Park",
      "h1_title": "Apts Near Haikey Creek Park 74133",
      "h2_subtitle": "Enjoy Cedar Glade Apts, ideally located near Haikey Creek Park in the 74133 zip code, offering tailored amenities and a scenic setting.",
      "page_copy": "Nestled in the vibrant 74133 zip code, Cedar Glade Apartments provides a perfect setting near the scenic Haikey Creek Park. Our prime location allows residents to enjoy the natural beauty and recreational opportunities the park offers, right at their doorstep.\n\nCedar Glade Apts features a selection of one, two, and three-bedroom apartments equipped with modern conveniences such as high-speed Internet and spacious patios. Community amenities include a revitalizing pool and a fitness center, offering a full suite of comforts in a serene environment. Experience the tranquil lifestyle near Haikey Creek Park when you call Cedar Glade home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
      "featured_image_media": {
        "alt_text": "Living room with a fireplace, coffee table, and sofa.",
        "public_id": "019cfb39-65bf-722c-ba7a-282719e2937d",
        "storage_key": "property/6767906449165588/019cfb39-65bf-722c-ba7a-282719e2937d.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Haikey Creek Park in 74133",
      "seo_description": "Find your home at Cedar Glade Apts near Haikey Creek Park in 74133. Enjoy amenities and a prime location for a comfortable lifestyle.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5151"
    },
    {
      "ID": "custom_ga4_id",
      "type": "STRING",
      "value": "G-Q6HZ93YXL6"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "10041151635"
    },
    {
      "ID": "custom_tour24_url",
      "type": "STRING",
      "value": "https://app.tour24now.com/prospect/tour/cedar-glade/register/"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-MDT8KBHL"
    },
    {
      "ID": "custom_floorplan_pdf_url",
      "type": "STRING",
      "value": "https://multihubmedia.com/property/6767906449165588/019d1bd7-22d2-713e-a608-cff4c55020de.pdf"
    },
    {
      "ID": "custom_rentgrata_property_id",
      "type": "STRING",
      "value": "0cdbd77d-859f-4863-9fab-cf7451d4a33b"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "844-669-4834"
    },
    {
      "ID": "custom_residentboost_apartment_id",
      "type": "STRING",
      "value": "644185360e554c5a9bb655cd"
    },
    {
      "ID": "custom_apartmentsync_javascript_id",
      "type": "STRING",
      "value": "eyJpdiI6ImFVbmhUMStvZm1KT0ZmV2p6bVF0eUE9PSIsInZhbHVlIjoiVk5MVlRHZmRTWUxqVE80ckc5bit2dz09IiwibWFjIjoiYTlmMWRkZjU0NWQ1ZmQ1MGQ2NDEyN2EwZmI3MjJjZDhmYzFlNWY0YzUyOGIzZjgwODc4MDMwMGIxN2ZlOGRiZSJ9"
    }
  ],
  "custom_qb_id": "5151",
  "custom_ga4_id": "G-Q6HZ93YXL6",
  "custom_repli_id": "10041151635",
  "custom_tour24_url": "https://app.tour24now.com/prospect/tour/cedar-glade/register/",
  "custom_google_gtm_id": "GTM-MDT8KBHL",
  "custom_floorplan_pdf_url": "https://multihubmedia.com/property/6767906449165588/019d1bd7-22d2-713e-a608-cff4c55020de.pdf",
  "custom_rentgrata_property_id": "0cdbd77d-859f-4863-9fab-cf7451d4a33b",
  "custom_ppc_tracking_phone_number": "844-669-4834",
  "custom_residentboost_apartment_id": "644185360e554c5a9bb655cd",
  "custom_apartmentsync_javascript_id": "eyJpdiI6ImFVbmhUMStvZm1KT0ZmV2p6bVF0eUE9PSIsInZhbHVlIjoiVk5MVlRHZmRTWUxqVE80ckc5bit2dz09IiwibWFjIjoiYTlmMWRkZjU0NWQ1ZmQ1MGQ2NDEyN2EwZmI3MjJjZDhmYzFlNWY0YzUyOGIzZjgwODc4MDMwMGIxN2ZlOGRiZSJ9"
};

export const generatedAt = '2026-08-27T21:39:34.461Z';
